import React, {
  useState,
  useEffect,
  useRef,
  useImperativeHandle,
  forwardRef,
} from "react";

import { v4 as v4Re, v6 as v6Re } from "cidr-regex";
import Alert from "../Alerts/Alerts";
import { useSelector, useDispatch } from "react-redux";
import {
  languageChange,
  currentSelectedLanguage,
  retainConfiguredData,
} from "../../../StateManagement/actions";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import EditIcon from "../../../assets/img/people.png";
import ModalPopUp from "../ModalPopUp/ModalPopUp";
import Select, { NonceProvider } from "react-select";
import '../../Shared/SendCreate/countryFlagStyles.css';
import { updateFormData } from '../../../StateManagement/formChanges-slice';
import { DLDetailsModal } from "../../Shared/SendCreate/Modals/DLDetailsModal";


//export default function MultipleEmails(props) {
const MultipleEmails = forwardRef((props, ref1) => {
  const dispatch = useDispatch();
  const data = useSelector((state) => state.pageLevelRestriction);
  const [consMultipleEmails, setConsMultipleEmails] = useState([]);
  const [selectedDLGroup, setSelectedDLGroup] = useState(null);
  const [isDLModalOpen, setIsDLModalOpen] = useState(false);
  const selectedLanguage = useSelector(currentSelectedLanguage);
  const [consEditMultipleEmails, setConsEditMultipleEmails] = useState(
    ["", "", "", [], "", "", ""],
  );
  const [consMultipleEmail, setConsMultipleEmail] = useState("");
  const [alertMsg, setAlertMsg] = useState("");
  const [alertType, setAlertType] = useState("");
  const [timer, setTimer] = useState("");
  const [placeholderText, setPlaceholderText] = useState(props.placeholder);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isModalFnLnEditOpen, setIsModalFnLnEditOpen] = useState(false);
  const [isValidationPopup, setIsValidationPopup] = useState(false);
  const [duplicateEmails, setDuplicateEmails] = useState([]);
  const [duplicateInFile, setDuplicateInFile] = useState([]);
  const [emailLeanghtValidation, setemailLeanghtValidation] = useState([]);
  const [invalidEmailsWithoutDotCom, setInvalidEmailsWithoutDotComValidation] =
    useState([]);
  const [invalidMobileNumbers, setInvalidMobileNumbers] = useState([]);
  const [unauthorizedCountryCodes, setUnauthorizedCountryCodes] = useState([]);
  const [duplicateMobileNumbers, setDuplicateMobileNumbers] = useState([]);
  const [missingMobileNumbers, setMissingMobileNumbers] = useState([]);
  const [invalidOption, setInvalidOption] = useState([]);
  const [textIsNotEnabled, setTextIsNotEnabled] = useState([]);
  const [emailIsNotEnabled, setEmailIsNotEnabled] = useState([]);
  const [missingCountryCodes, setMissingCountryCodes] = useState([]);
  const [localpartValiadation, setLocalpartValiadation] = useState([]);
  const [longDomainEmails, setLongDomainEmails] = useState([]);
  const [constEmailsFromCSV, setConstEmailsFromCSV] = useState([]);
  const [ReadersinputFields, setReadersinputFields] = useState([]);
  const [constmultipleEmails, setConstMultipleEmails] = useState([]);
  const [AddDragActive, setAddDragActive] = useState(false);
  const [ReadersfileName, setReadersFileName] = useState("");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [reference, setReference] = useState("");
  const [isModalFnLnOpen, setIsModalFnLnOpen] = useState("");
  const [currentEmail, setCurrentEmail] = useState("");
  const [currentIndex, setCurrentIndex] = useState("");
  const [longFirstName, setLongFirstName] = useState([]);
  const [longLastName, setLongLastName] = useState([]);
  const addReaderFocusRef = useRef(null);
  const [longReference, setLongReference] = useState([]);
  const [selectVerificationCode, setSelectVerificationCode] = useState("");
  const [bothIsNotEnabled, setBothIsNotEnabled] = useState([]);
  const [invalidCanPrintValues, setInvalidCanPrintValues] = useState([]);
  const [exceedMaxPrintsPerDoc, setExceedMaxPrintsPerDoc] = useState([]);
  const [maxPrintsWithoutCanPrint, setMaxPrintsWithoutCanPrint] = useState([]);
  const [canPrintNotEnabledAtDocLevel, setCanPrintNotEnabledAtDocLevel] = useState([]);
  const [maxPrintsExceedLimit, setMaxPrintsExceedLimit] = useState([]);
  const [invalidMaxPrintsValues, setInvalidMaxPrintsValues] = useState([]);
  const unWarningModal = useRef();
  const ggEditorRemovedInPopupRef = useRef(false);
  const endRef = useRef(null);
  const [shouldScroll, setShouldScroll] = useState(false);
  const [canPrint, setPrint] = useState(false);
  const [maxPrintsPerReaderText, setMaxPrintsPerReaderText] = useState(props.defaultCanPrint ? props.defaultMaxPrintsPerReader : "");
  const [maxPrintsPerDocumentText, setMaxPrintsPerDocumentText] = useState(props.defaultMaxPrintsPerDocument);
  const [position, setPosition] = useState(null);
  const handleMouseEnter = (e) => {
    const box = e.target.getBoundingClientRect();
    const { top, bottom, left, right } = box;
    const centerX = left + (right - left) / 2;
    const centerY = top + (bottom - top) / 2;
    const newPosition = centerY < window.innerHeight / 2 ? "bottom" : "top";
    setPosition(newPosition);
  };
  useEffect(() => {
    if (addReaderFocusRef.current != null)
      addReaderFocusRef.current.focus();
  }, [isModalFnLnEditOpen]);
  useEffect(() => {
    fetchCountryCodes();
  }, []);
  useEffect(() => {
    if (props.IsModelOpenChild) {
      handleReceiptsFnLnEdit(null);
      props.setIsModelOpenChild(false);
    }
  }, [props.IsModelOpenChild]);
  useEffect(() => {
    if (shouldScroll && endRef.current) {
      endRef.current.scrollIntoView({ behavior: "smooth" });
      setShouldScroll(false); // reset so it doesn’t scroll again
    }
  }, [consEditMultipleEmails, shouldScroll]);

  function removeEmail(EmailsList, Email, id, skipGridGuardCheck) {
    const ggEditors = ((props.getGridGuardEditors && props.getGridGuardEditors()) || []).map((e) => String(e).toLowerCase());
    const ggTarget = String(Email[0] || "").toLowerCase();
    const ggOtherEditors = (data.authorizedReaders || []).filter((r) => {
      const e = String(r[0] || "").toLowerCase();
      return e !== ggTarget && ggEditors.includes(e);
    });
    if (ggEditors.includes(ggTarget) && ggOtherEditors.length === 0 && unWarningModal.current && typeof unWarningModal.current.open === "function") {
      unWarningModal.current.open(selectedLanguage.LstLanguageCodes.UI_GG_Readerwillberemoved,
        () => {
          removeEmailFromInput(); // Confirm: your normal removal
          if (props.onGridGuardEditorsRemoved) props.onGridGuardEditorsRemoved(); // uncheck + reset GridGuard
        },
        () => { } // Cancel: just close, email is not removed
      );
      return;
    }
    if (props.RestrictionReaders && props.RestrictionReaders.some((reader) => reader === Email[0])) {
      if (props.isPageLevelRestriction) {
        let msg =
          selectedLanguage.LstLanguageCodes
            .UI_AllConfiguredRestrictionsSetRemoved;

        if (
          unWarningModal.current &&
          typeof unWarningModal.current.open === "function"
        ) {
          unWarningModal.current.open(
            msg,
            () => {
              removeEmailFromInput();
            },
            () => { }
          );
        } else {
          console.error(
            "unWarningModal is not initialized or missing open function."
          );
        }
      } else {
        removeEmailFromInput();
      }
    } else {
      removeEmailFromInput();
    }

    function removeEmailFromInput() {
      if (data.authorizedReaders.length == 1) {
        setPlaceholderText(props.placeholder);
      }
      const tempMultiEmails = data.authorizedReaders.filter(
        (reader) =>
          reader[0]?.toLowerCase() !== Email[0]?.toLowerCase()
      );
      const updatedRecipientPrintData = props.recipientPrintData.filter(
        (reader) =>
          reader[0]?.toLowerCase() !== Email[0]?.toLowerCase()
      );

      if (props.onRecipientPrintDataUpdate) {
        props.onRecipientPrintDataUpdate(updatedRecipientPrintData);
      }

      const noReadersRestrictions = data.pageLevelRestrictionData.filter(
        (item) =>
          item.category === selectedLanguage.LstLanguageCodes.UI_NoReaders
      );

      dispatch(
        retainConfiguredData({
          isConfirm: data.onConfirm,
          authorizedReaders: tempMultiEmails,
          pageRestrictionData:
            tempMultiEmails.length > 0
              ? data.pageLevelRestrictionData
              : noReadersRestrictions,
        })
      );
      setConsMultipleEmails(tempMultiEmails);
      props.recipientDetailsFromChaild(tempMultiEmails, true);
    }
  }


  const deepCopyArray = arr => {
    return arr.map(item => {
      if (Array.isArray(item)) {
        return deepCopyArray(item); // If item is an array, recursively copy it
      } else if (typeof item === 'object' && item !== null) {
        // If item is an object, create a shallow copy
        // You might need to implement a deep copy if object properties are also arrays or objects
        return { ...item };
      } else {
        return item; // Base case: return primitive values
      }
    });
  };
  // Check if an entered email is already a part of any DL in the TO section
  const isEmailInEnteredDL = (emailToCheck, list = null, excludeIndex = -1) => {
    if (!emailToCheck) return false;
    const target = emailToCheck.trim().toLowerCase();
    const readers = list || (data.authorizedReaders?.length > 0 ? data.authorizedReaders : consMultipleEmails) || [];
    return readers.some((r, idx) => {
      if (idx === excludeIndex || !r) return false;
      if (r[10] !== true && r[2] !== "(DL)") return false;
      const grp = r[11] || (props.contactGroups || []).find((g) => {
        const alias = (g.aliasEmail || g.email || g.name || "").trim().toLowerCase();
        return alias === (r[0] || "").trim().toLowerCase();
      });
      if (!grp) return false;
      const memberIds = grp.memberContactIds || grp.MemberContactIds || grp.members || [];
      return memberIds.some((m) => {
        const mStr = String(m?.email || m || "").trim().toLowerCase();
        if (mStr === target) return true;
        const c = (props.contacts || []).find((c) => (c.id || c._id || c.Id) === m);
        return c && (c.email || c.Email || "").trim().toLowerCase() === target;
      });
    });
  };

  const removeInputFields = (emailsList, email, index) => {
    const ggEditors = ((props.getGridGuardEditors && props.getGridGuardEditors()) || []).map((e) => String(e).toLowerCase());
    const ggTarget = String(email || "").toLowerCase();
    const ggOtherEditors = consEditMultipleEmails.filter((r) => {
      const e = String(r[0] || "").toLowerCase();
      return e && e !== ggTarget && ggEditors.includes(e);
    });
    if (ggEditors.includes(ggTarget) && ggOtherEditors.length === 0 && unWarningModal.current && typeof unWarningModal.current.open === "function") {
      unWarningModal.current.open(selectedLanguage.LstLanguageCodes.UI_GG_Readerwillberemoved,
        () => {
          ggEditorRemovedInPopupRef.current = true;
          setTimeout(() => removeInputFieldsContinue(email, index), 0); // Defer so this modal is fully closed before any follow-up restriction warning opens.
        },
        () => { } // Cancel: reader stays
      );
      return;
    }
    removeInputFieldsContinue(email, index);
  };

  const removeInputFieldsContinue = (email, index) => {
    const rows = deepCopyArray(consEditMultipleEmails);
    function removeEmailFromInput() {
      if (data.authorizedReaders.length == 1) {
        setPlaceholderText(props.placeholder);
      }
      const tempMultiEmails = data.authorizedReaders.filter(
        (reader) => reader[0] && reader[0].toLowerCase() !== email.toLowerCase()
      );

      const noReadersRestrictions = data.pageLevelRestrictionData.filter(
        (item) =>
          item.category === selectedLanguage.LstLanguageCodes.UI_NoReaders
      );

      dispatch(
        retainConfiguredData({
          isConfirm: data.onConfirm,
          authorizedReaders: tempMultiEmails,
          pageRestrictionData:
            tempMultiEmails.length > 0
              ? data.pageLevelRestrictionData
              : noReadersRestrictions,
        })
      );
      setConsMultipleEmails(tempMultiEmails);
      props.recipientDetailsFromChaild(tempMultiEmails, true);
    }
    if (props.RestrictionReaders && props.RestrictionReaders.length > 0 && props.RestrictionReaders.some((reader) => reader === email)) {
      if (props.isPageLevelRestriction) {
        let msg =
          selectedLanguage.LstLanguageCodes
            .UI_AllConfiguredRestrictionsSetRemoved;

        if (
          unWarningModal.current &&
          typeof unWarningModal.current.open === "function"
        ) {
          unWarningModal.current.open(
            msg,
            () => {
              removeEmailFromInput();
              rows.splice(index, 1);
              setConsEditMultipleEmails(rows);
            },
            () => { }
          );
        } else {
          console.error(
            "unWarningModal is not initialized or missing open function."
          );
        }
      }
      else {
        removeEmailFromInput();
        // rows.splice(index, 1);
        // setConsEditMultipleEmails(rows);
      }
    }
    else if (data.pageLevelRestrictionData && data.pageLevelRestrictionData.some((restriction) => restriction.readers && restriction.readers.includes(email))) {
      if (props.isPageLevelRestriction) {
        let msg =
          selectedLanguage.LstLanguageCodes
            .UI_AllConfiguredRestrictionsSetRemoved;

        if (
          unWarningModal.current &&
          typeof unWarningModal.current.open === "function"
        ) {
          unWarningModal.current.open(
            msg,
            () => {
              removeEmailFromInput();
              rows.splice(index, 1);
              setConsEditMultipleEmails(rows);
            },
            () => { }
          );
        } else {
          console.error(
            "unWarningModal is not initialized or missing open function."
          );
        }
      } else {
        removeEmailFromInput();
      }
    }
    else {
      rows.splice(index, 1);
      setConsEditMultipleEmails(rows);
    }
  };
  const addInputField = () => {
    setShouldScroll(true);
    setConsEditMultipleEmails((prevEmails) => [
      ...prevEmails,
      ["", "", "", [], "", "", "", props.defaultCanPrint || false, props.defaultCanPrint ? props.defaultMaxPrintsPerReader : ""]
    ]);
    if (endRef.current)
      endRef.current.scrollIntoView({ behavior: "smooth" });
  };

  const handlerModelConfirmForAddUser = () => {
    let validation = 0;
    const emailSet = new Set();
    const mobileSet = new Set();
    consEditMultipleEmails.forEach((emails, index) => {
      if (emails?.[0]) {
        emails[0] = emails[0].trim();
      }
      const rawTarget = (emails[0] || "").trim().toLowerCase();
      const matchedGroup = (props.contactGroups || []).find((g) => {
        if (!g) return false;
        const gAlias = (g.aliasEmail || g.AliasEmail || g.email || g.Email || g.dlEmail || "").trim().toLowerCase();
        const gName = (g.name || g.Name || g.groupName || g.GroupName || "").trim().toLowerCase();
        const gAliasPrefix = gAlias ? gAlias.split("@")[0].toLowerCase() : "";
        return (gAlias && gAlias === rawTarget) || (gName && gName === rawTarget) || (gAliasPrefix && gAliasPrefix === rawTarget);
      });
      const matchedContact = !matchedGroup ? (props.contacts || []).find((c) => {
        if (!c) return false;
        const cEmail = (c.email || c.Email || "").trim().toLowerCase();
        return cEmail && cEmail === rawTarget;
      }) : null;

      const canonicalEmail = (
        matchedGroup ? (matchedGroup.aliasEmail || matchedGroup.AliasEmail || matchedGroup.email || matchedGroup.Email || matchedGroup.dlEmail || matchedGroup.name || matchedGroup.Name || rawTarget) :
          matchedContact ? (matchedContact.email || matchedContact.Email || rawTarget) :
            rawTarget
      ).trim().toLowerCase();

      const isDLRow = Boolean(emails[10] === true || emails.isGroup || emails.isDLGroup || emails[2] === "(DL)" || emails[2] === "(Distribution List)" || matchedGroup);
      if (validation === 0) {
        if (canonicalEmail && emailSet.has(canonicalEmail)) {
          validation = 3;
        } else if (canonicalEmail) {
          emailSet.add(canonicalEmail);
        }
        if (!isDLRow && emails[4] && emails[4].value != null && emails[4].value !== "+Code" && emails[5]) {
          const duplicateMobile = `${emails[4]?.value || emails[4]}-${emails[5]?.value || emails[5]}`;
          if (mobileSet.has(duplicateMobile)) {
            validation = 8;
          } else {
            mobileSet.add(duplicateMobile);
          }
        }

        if (validation === 0) {
          if (emails[0] === "") {
            validation = 1;
          } else if (
            !isDLRow && !/^[\w.\-]+@[a-zA-Z0-9.\-]+\.[a-zA-Z]{2,63}$/.test(emails[0])
          ) {
            validation = 2;
          } else if (emails[1] != null && emails[1].trim().length > 50) {
            validation = 4;
          } else if (emails[2] != null && emails[2].trim().length > 50) {
            validation = 5;
          } else if (!isDLRow &&
            (emails[3]?.value === "text" || emails[3]?.value === "both") &&
            (!emails[5] || emails[5].toString().trim() === "")
          ) {
            validation = 6; // Validation message: "Please enter mobile number."
          } else if (!isDLRow && emails[5] && emails[5].toString().trim() !== "" && (!emails[4] || emails[4] === "" || emails[4] === "+Code" || emails[4]?.value === "+Code")
          ) {
            validation = 7; // Validation message: "Please select country code."
          } else if (
            !isDLRow &&
            emails[5] &&
            emails[4]?.mobileMaxLeng &&
            emails[5].length !== emails[4]?.mobileMaxLeng
          ) {
            validation = 9; // Validation message: "Please enter a valid mobile number."
          } else if (emails[6] && emails[6].trim().length > 50) {
            validation = 10;
          } else if (props.defaultMaxPrintsPerDocument !== "" && emails[7] && emails[8] > props.defaultMaxPrintsPerDocument) {
            validation = 11;
          } else if (!isDLRow && isEmailInEnteredDL(canonicalEmail, consEditMultipleEmails, index)) {
            validation = 12;
          }
        }
      }
    });

    // Handle validation errors
    if (validation === 1) {
      setAlertMsg(selectedLanguage.LstLanguageCodes.UI_Pleaseentervalidmail);
      setAlertType("warning");
      return;
    } else if (validation === 2) {
      setAlertMsg(selectedLanguage.LstLanguageCodes.UI_Pleaseentervalidmail);
      setAlertType("warning");
      return;
    } else if (validation === 3) {
      setAlertMsg(selectedLanguage.LstLanguageCodes.UI_DuplicateEmailNotallowed);
      setAlertType("warning");
      setConsMultipleEmail("");
      setIsModalFnLnEditOpen(false);

      const seenKeys = new Set();
      let arrayTemp = [];
      consEditMultipleEmails.forEach((emails) => {
        const trimmedEmail = (emails[0] || "").trim();
        const lowerEmail = trimmedEmail.toLowerCase();
        const matchedGroup = (props.contactGroups || []).find((g) => {
          if (!g) return false;
          const gName = (g.name || g.Name || g.groupName || g.GroupName || "").trim().toLowerCase();
          const gAlias = (g.aliasEmail || g.AliasEmail || g.email || g.Email || g.dlEmail || "").trim().toLowerCase();
          const gAliasPrefix = gAlias ? gAlias.split("@")[0].toLowerCase() : "";
          return (gAlias && gAlias === lowerEmail) || (gName && gName === lowerEmail) || (gAliasPrefix && gAliasPrefix === lowerEmail);
        });
        const matchedContact = !matchedGroup ? (props.contacts || []).find((c) => {
          if (!c) return false;
          const cEmail = (c.email || c.Email || "").trim().toLowerCase();
          return cEmail && cEmail === lowerEmail;
        }) : null;

        const canonicalEmail = (
          matchedGroup ? (matchedGroup.aliasEmail || matchedGroup.AliasEmail || matchedGroup.email || matchedGroup.Email || matchedGroup.dlEmail || matchedGroup.name || matchedGroup.Name || lowerEmail) :
            matchedContact ? (matchedContact.email || matchedContact.Email || lowerEmail) :
              lowerEmail
        ).trim().toLowerCase();

        if (canonicalEmail && !seenKeys.has(canonicalEmail)) {
          seenKeys.add(canonicalEmail);
          let finalEmail = trimmedEmail;
          let finalFirstName = emails[1]?.trim() || "";
          let finalLastName = emails[2]?.trim() || "";
          let isDLGroup = Boolean(emails[10]);
          let groupObj = emails[11] || null;

          if (matchedGroup) {
            finalEmail = matchedGroup.aliasEmail || matchedGroup.AliasEmail || matchedGroup.email || matchedGroup.Email || matchedGroup.name || matchedGroup.Name || trimmedEmail;
            finalFirstName = matchedGroup.name || matchedGroup.Name || matchedGroup.groupName || matchedGroup.GroupName || "Distribution List";
            finalLastName = "(DL)";
            isDLGroup = true;
            groupObj = matchedGroup;
          }

          arrayTemp.push([
            finalEmail,
            finalFirstName,
            finalLastName,
            emails[3], // Verification options
            isDLGroup ? "" : emails[4], // Mobile country code
            isDLGroup ? "" : emails[5], // Mobile number
            isDLGroup ? "" : (emails[6]?.trim() || ""), // Reference
            emails[7], // Can Print
            emails[8], // Max reads per reader
            emails[9], // isEdited flag
            isDLGroup,
            groupObj
          ]);
        }
      });

      if (props.onRecipientPrintDataUpdate) {
        props.onRecipientPrintDataUpdate(deepCopyArray(arrayTemp));
      }
      dispatch(retainConfiguredData({ ...data, authorizedReaders: arrayTemp }));
      setConsMultipleEmails(arrayTemp);
      props.recipientDetailsFromChaild(arrayTemp);
      return;
    } else if (validation === 4) {
      setAlertMsg(selectedLanguage.LstLanguageCodes.UI_FirstNameMoreThanFifty);
      setAlertType("warning");
      return;
    } else if (validation === 5) {
      setAlertMsg(selectedLanguage.LstLanguageCodes.UI_LastNameMoreThanFifty);
      setAlertType("warning");
      return;
    } else if (validation === 6) {
      setAlertMsg(selectedLanguage.LstLanguageCodes.UI_PleaseEnterMobileNumber);
      setAlertType("warning");
      return;
    } else if (validation === 7) {
      setAlertMsg(selectedLanguage.LstLanguageCodes.UI_PleaseSelectCountryCode);
      setAlertType("warning");
      return;
    } else if (validation === 8) {
      setAlertMsg(selectedLanguage.LstLanguageCodes.UI_DuplicateMobileNum);
      setAlertType("warning");
      return;
    }
    else if (validation === 9) {
      setAlertMsg(selectedLanguage.LstLanguageCodes.UI_PleaseEnterValidNumber);
      setAlertType("warning");
      return;
    } else if (validation === 10) {
      setAlertMsg(selectedLanguage.LstLanguageCodes.UI_ReferenceMoreThanFifty);
      setAlertType("warning");
      return;
    } else if (validation === 11) {
      setAlertMsg(selectedLanguage.LstLanguageCodes.UI_Printsperreadercannotexceedprintspersdocument);
      setAlertType("warning");
      return;
    } else if (validation === 12) {
      setAlertMsg(selectedLanguage?.LstLanguageCodes?.UI_EmailAlreadyExistsInGroup);
      setAlertType("warning");
      return;
    }
    else {
      let arrayTemp = consEditMultipleEmails.map((emails) => {
        const trimmedEmail = (emails[0] || "").trim();
        const lowerEmail = trimmedEmail.toLowerCase();
        // Check if edited email matches any DL Group in contactGroups
        const matchedGroup = (props.contactGroups || []).find((g) => {
          if (!g) return false;
          const gName = (g.name || g.Name || g.groupName || g.GroupName || "").trim().toLowerCase();
          const gAlias = (g.aliasEmail || g.AliasEmail || g.email || g.Email || g.dlEmail || "").trim().toLowerCase();
          const gAliasPrefix = gAlias ? gAlias.split("@")[0].toLowerCase() : "";
          return (gAlias && gAlias === lowerEmail) || (gName && gName === lowerEmail) || (gAliasPrefix && gAliasPrefix === lowerEmail);
        });

        let finalEmail = trimmedEmail;
        let finalFirstName = emails[1]?.trim() || "";
        let finalLastName = emails[2]?.trim() || "";
        let isDLGroup = Boolean(emails[10]);
        let groupObj = emails[11] || null;

        if (matchedGroup) {
          finalEmail = matchedGroup.aliasEmail || matchedGroup.AliasEmail || matchedGroup.email || matchedGroup.Email || matchedGroup.name || matchedGroup.Name || trimmedEmail;
          finalFirstName = matchedGroup.name || matchedGroup.Name || matchedGroup.groupName || matchedGroup.GroupName || "Distribution List";
          finalLastName = "(DL)";
          isDLGroup = true;
          groupObj = matchedGroup;
        }

        return [
          finalEmail,
          finalFirstName,
          finalLastName,
          emails[3], // Verification options
          isDLGroup ? "" : emails[4], // Mobile country code
          isDLGroup ? "" : emails[5], // Mobile number
          isDLGroup ? "" : (emails[6]?.trim() || ""), // Reference
          emails[7], // Can Print
          emails[8], // Max reads per reader
          emails[9], // isEdited flag
          isDLGroup,
          groupObj
        ];
      });
      if (props.onRecipientPrintDataUpdate) {
        props.onRecipientPrintDataUpdate(deepCopyArray(arrayTemp));
      }
      dispatch(retainConfiguredData({ ...data, authorizedReaders: arrayTemp }));
      setConsMultipleEmails(arrayTemp);
      props.recipientDetailsFromChaild(arrayTemp);
      if (ggEditorRemovedInPopupRef.current) {
        ggEditorRemovedInPopupRef.current = false;
        const ggEditors = ((props.getGridGuardEditors && props.getGridGuardEditors()) || []).map((e) => String(e).toLowerCase());
        const stillHasEditor = arrayTemp.some((r) => ggEditors.includes(String(r[0] || "").toLowerCase()));
        if (!stillHasEditor && props.onGridGuardEditorsRemoved) props.onGridGuardEditorsRemoved();
      }
      setIsModalFnLnEditOpen(false);
    }
  };


  const handlerModelCancelForAddUser = () => {
    ggEditorRemovedInPopupRef.current = false;
    setIsModalFnLnEditOpen(false);
    setConsEditMultipleEmails([]);
  };
  const handleChange = (index, evnt) => {
    const { name, value } = evnt.target;
    const nameTemp = name.split('-')[0];
    let list = [];
    list = deepCopyArray(consEditMultipleEmails);

    switch (nameTemp) {
      case "firstName":
        list[index][1] = value;
        break;
      case "lastName":
        list[index][2] = value;
        break;
      case "email":
        const emailVal = evnt.type === "blur" ? value.trim() : value;
        list[index][0] = emailVal;
        if (evnt.type === "blur" && emailVal) {
          const lowerE = emailVal.toLowerCase();
          const matchedContact = (props.contacts || []).find((c) => {
            if (!c) return false;
            const cEmail = (c.email || c.Email || "").trim().toLowerCase();
            return cEmail && cEmail === lowerE;
          });
          if (matchedContact) {
            if (!list[index][1]) list[index][1] = matchedContact.firstName || matchedContact.FirstName || "";
            if (!list[index][2]) list[index][2] = matchedContact.lastName || matchedContact.LastName || "";
            if (!list[index][5]) list[index][5] = matchedContact.mobile || matchedContact.Mobile || "";
            if (!list[index][6]) list[index][6] = matchedContact.referenceTag || matchedContact.ReferenceTag || "";
            if (!list[index][4] || list[index][4] === "" || list[index][4]?.value === "+Code") {
              const rawCC = matchedContact.phoneCode || matchedContact.PhoneCode || "";
              list[index][4] = resolveCountryCode(rawCC) || (rawCC ? { value: rawCC, label: rawCC } : "");
            }
          }
        }
        break;
      case "countryCode":
        list[index][4] = value;
        break;
      case "mobileNumber":
        list[index][5] = value;
        break;
      case "verificationType":
        list[index][3] = value;
        break;
      case "reference":
        list[index][6] = value;
        break;
      case "canPrint":
        list[index][7] = evnt.target.checked;
        break;
      case "maxPrintsPerReader":
        let printValue = value?.replace(/[^0-9]+/g, "");
        if (printValue === "" || (printValue.length <= 4 && parseInt(printValue, 10) >= 1 && parseInt(printValue, 10) <= 9999)) {
          list[index].maxPrintsPerReader = printValue === "" ? "" : parseInt(printValue, 10);
          if (printValue !== "") {
            list[index].previousMaxPrintsPerReader = parseInt(printValue, 10);
          }
          list[index][8] = list[index].maxPrintsPerReader;
          list[index][9] = true;
        }
        break;
      default:
        console.warn(`Unhandled field: ${nameTemp}`);
        break;
    }
    setConsEditMultipleEmails(list);
  };

  const handleReceiptsAdding = () => {
    setIsModalOpen(true);
  };

  useImperativeHandle(ref1, () => ({
    clearEmails() {
      setConsMultipleEmails([]);
      props.recipientDetailsFromChaild([]);
    },
    assignEmails(fileData) {
      setConsMultipleEmails(fileData);
      props.recipientDetailsFromChaild(fileData);
    },
  }));
  // useEffect(() => {
  //   clearTimeout(timer);
  //   setTimer(
  //     setTimeout(() => {
  //       setAlertMsg("");
  //       setAlertType("");
  //     }, 5000)
  //   );
  // }, [alertType]);

  // useEffect(() => {
  // setConsMultipleEmails(props.constmultipleemails);
  //   props.recipientDetailsFromChaild(props.constmultipleemails);
  // }, [props.constmultipleemails]);

  function handlerKeyPress(event) {
    //console.log("handlerKeyPress " + event.keyCode);
  }

  function handleKeyDown(event) {
    if (
      event.keyCode == 186 ||
      event.keyCode == 13 ||
      event.keyCode == 27 ||
      event.keyCode == 59 ||
      (event.keyCode == undefined && event.type == "blur")
    ) {
      const Trimmedemail = consMultipleEmail.trim();
      if (Trimmedemail == "") {
        if (!(event.keyCode == undefined && event.type == "blur")) {
          setAlertMsg(
            selectedLanguage.LstLanguageCodes.UI_Pleaseentervalidmail
          );
          setAlertType("warning");
        }
        setConsMultipleEmail("");
        return;
      }

      // 1. Search if input matches a Contact Group / DL in company/personal groups
      const matchedGroup = (props.contactGroups || []).find((g) => {
        if (!g) return false;
        const gName = (g.name || g.Name || g.groupName || g.GroupName || "").trim().toLowerCase();
        const gAlias = (g.aliasEmail || g.AliasEmail || g.email || g.Email || g.dlEmail || "").trim().toLowerCase();
        const gAliasPrefix = gAlias ? gAlias.split("@")[0].toLowerCase() : "";
        const target = Trimmedemail.toLowerCase();
        return (gAlias && gAlias === target) || (gName && gName === target) || (gAliasPrefix && gAliasPrefix === target);
      });

      // 2. Search if input matches a saved Contact in company/personal contacts
      const matchedContact = !matchedGroup ? (props.contacts || []).find((c) => {
        if (!c) return false;
        const cEmail = (c.email || c.Email || "").trim().toLowerCase();
        return cEmail && cEmail === Trimmedemail.toLowerCase();
      }) : null;

      let emailToAdd = Trimmedemail;
      let firstNameToAdd = "";
      let lastNameToAdd = "";
      let phoneCodeToAdd = "";
      let mobileToAdd = "";
      let referenceToAdd = "";
      let isDLGroup = false;

      if (matchedGroup) {
        emailToAdd = matchedGroup.aliasEmail || matchedGroup.AliasEmail || matchedGroup.email || matchedGroup.Email || matchedGroup.dlEmail || matchedGroup.name || matchedGroup.Name || Trimmedemail;
        firstNameToAdd = matchedGroup.name || matchedGroup.Name || matchedGroup.groupName || matchedGroup.GroupName || "Distribution List";
        lastNameToAdd = "(DL)";
        isDLGroup = true;
      } else if (matchedContact) {
        emailToAdd = matchedContact.email || matchedContact.Email;
        firstNameToAdd = matchedContact.firstName || matchedContact.FirstName || "";
        lastNameToAdd = matchedContact.lastName || matchedContact.LastName || "";
        const rawPhoneCode = matchedContact.phoneCode || matchedContact.PhoneCode || "";
        phoneCodeToAdd = resolveCountryCode(rawPhoneCode) || (rawPhoneCode ? { value: rawPhoneCode, label: rawPhoneCode } : "");
        mobileToAdd = matchedContact.mobile || matchedContact.Mobile || "";
        referenceToAdd = matchedContact.referenceTag || matchedContact.ReferenceTag || "";
      } else {
        // Validation check for un-saved raw email entries
        if (!/^[\w\.\-]+@[a-zA-Z0-9\.\-]+\.[a-zA-Z]{2,63}$/.test(
          Trimmedemail
        )
        ) {
          setAlertMsg(selectedLanguage.LstLanguageCodes.UI_Pleaseentervalidmail);
          setAlertType("warning");
          event.stopPropagation();
          event.preventDefault();
          return;
        }
      }
      const emailExists = data.authorizedReaders.some((innerArray) => innerArray[0]?.toLowerCase() === emailToAdd.toLowerCase());
      if (emailExists) {
        setAlertMsg(
          selectedLanguage.LstLanguageCodes.UI_DuplicateEmailNotallowed
        );
        setAlertType("warning");
        setConsMultipleEmail("");
      } else if (!isDLGroup && isEmailInEnteredDL(emailToAdd)) {
        setAlertMsg(selectedLanguage?.LstLanguageCodes?.UI_EmailAlreadyExistsInGroup);
        setAlertType("warning");
        setConsMultipleEmail("");
      } else {
        const newTuple = [
          emailToAdd,
          firstNameToAdd,
          lastNameToAdd,
          [],
          phoneCodeToAdd,
          mobileToAdd,
          referenceToAdd,
          props.defaultCanPrint || false,
          props.defaultCanPrint ? props.defaultMaxPrintsPerReader : "",
          false,
          isDLGroup,
          matchedGroup || null
        ];

        setConsMultipleEmails((prev) => {
          if (prev.length === 0 && data.authorizedReaders.length > 0) {
            return [...data.authorizedReaders, newTuple];
          }
          return [...prev, newTuple];
        });

        const currentReaders = consMultipleEmails.length === 0 && data.authorizedReaders.length > 0 ? data.authorizedReaders : consMultipleEmails;
        props.recipientDetailsFromChaild([...currentReaders, newTuple]);
        setConsMultipleEmail("");
        setPlaceholderText("");
      }
      event.stopPropagation();
      event.preventDefault();
    }
  }
  let VerificationOptions = [];

  if (props.selectedOptions && props.selectedOptions.length === 2) {
    VerificationOptions = [
      ...props.selectedOptions,
      { value: "both", label: selectedLanguage.LstLanguageCodes.UI_Both },
    ];
  } else {
    VerificationOptions = props.selectedOptions || [];
  }
  let VerificationOptionsForFilter = [
    { value: "both", label: selectedLanguage.LstLanguageCodes.UI_Both },
    { value: "email", label: selectedLanguage.LstLanguageCodes.UI_Email },
    { value: "text", label: selectedLanguage.LstLanguageCodes.UI_Text },
  ]
  const globePlaceholder = {
    label: "+Code",
    value: "+Code",
    languageCode: "+Code", // Used to show the globe icon
    isPlaceholder: true
  };
  function handleKeyUp(event) {
    //kdsf
  }
  const ref = useRef(null);

  const handleClick = () => {
    ref.current.focus();
  };
  const fileNameChange = (indexValChange, val) => {
    var arrayTemp = [];
    arrayTemp.push(...consMultipleEmails);

    for (let index = 0; index < arrayTemp.length; index++) {
      if (arrayTemp[index].indexVal == indexValChange) {
        arrayTemp[index].mdfFileName = val;
      }
      setConsMultipleEmails(arrayTemp);
      props.recipientDetailsFromChaild(arrayTemp);
    }
  };
  const [selectedCode, setSelectedCode] = useState("");
  const [mobileNumber, setMobileNumber] = useState("");
  const [languageCode, setLanguageCode] = useState("");
  const [countryCodeOptions, setCountryCodeOptions] = useState("");
  const [countryCodeDrpOptions, setCountryCodedrpOptions] = useState([]);

  const resolveCountryCode = (val, customOptions = countryCodeOptions, customDrp = countryCodeDrpOptions) => {
    if (!val || val === "+Code") return null;
    if (typeof val === "object" && val !== null && val.value && val.value !== "+Code" && val.label && val.languageCode !== undefined) {
      return val;
    }
    const rawStr = typeof val === "string" ? val.trim() : (val?.value || "").trim();
    if (!rawStr || rawStr === "+Code") return null;
    const normalized = rawStr.startsWith("+") ? rawStr : `+${rawStr}`;
    const dialOnly = normalized.split("-")[0];
    const opts = Array.isArray(customOptions) ? customOptions : [];
    const drp = Array.isArray(customDrp) ? customDrp : [];
    let found = drp.find((c) => c && (c.value === dialOnly || c.value === normalized));
    if (!found) {
      found = opts.find((c) => c && (c.value === normalized || c.value?.split("-")[0] === dialOnly));
    }
    if (!found) {
      found = opts.find((c) => c && c.label && c.label.includes(`(${dialOnly})`));
    }
    if (found) {
      return {
        value: dialOnly,
        label: found.label,
        languageCode: found.languageCode || "",
        mobileMaxLeng: found.mobileMaxLeng || 10
      };
    }
    return {
      value: dialOnly,
      label: dialOnly,
      languageCode: "",
      mobileMaxLeng: 10
    };
  };
  const handleVerificationChange = (selectedOption, index) => {

    if (index !== undefined) {
      setConsEditMultipleEmails(consEditMultipleEmails.map((prevEmails, locIndex) => {
        if (locIndex === index) {
          const updatedEmails = [...prevEmails];
          updatedEmails[3] = selectedOption;
          return updatedEmails;
        }
        return prevEmails;
      }));
    } else {
      setSelectVerificationCode(selectedOption);
    }
  }
  const handleCodeChange = (selectedOption, index) => {
    if (selectedOption.value.includes('-')) {
      selectedOption.value = selectedOption.value.split('-')[0];
    }
    if (selectedOption.languageCode == 'ca') {
      const updatedOptions1 = countryCodeDrpOptions.map((option) => {
        // Check if the languageCode is "us", and if so, update the value
        if (option.languageCode != 'ca' || option.languageCode == '') {
          return { ...option, value: `${option.value.split('-')[0]}-${option.languageCode.toUpperCase()}` }; // Update value for US
        }
        // Leave other options unchanged
        return option;
      });

      setCountryCodeOptions(updatedOptions1);
    }
    if (selectedOption.languageCode == 'us') {
      const updatedOptions2 = countryCodeDrpOptions.map((option) => {
        // Check if the languageCode is "us", and if so, update the value
        if (option.languageCode != 'us' || option.languageCode == '') {
          return { ...option, value: `${option.value.split('-')[0]}-${option.languageCode.toUpperCase()}` }; // Update value for US
        }
        // Leave other options unchanged
        return option;
      });
      setCountryCodeOptions(updatedOptions2);
    }
    if (index !== undefined) {
      setConsEditMultipleEmails(consEditMultipleEmails.map((prevEmails, locIndex) => {
        if (locIndex === index) {
          const updatedEmails = [...prevEmails]; // Copy the previous array
          updatedEmails[4] = selectedOption;  // Update index 3 with the new value
          return updatedEmails;                // Return the updated array
        }
        return prevEmails;                      // Return unchanged arrays for other indices
      }));
    } else {
      setSelectedCode(selectedOption);
    }
  };
  const selectRef = useRef(null);
  const [menuIsOpen, setMenuIsOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (menuIsOpen) {
        setMenuIsOpen(false); // close menu on scroll
      }
    };

    window.addEventListener("scroll", handleScroll, true);
    return () => {
      window.removeEventListener("scroll", handleScroll, true);
    };
  }, [menuIsOpen]);

  const handleMobileChange = (event, index) => {
    let input = event.target.value;
    input = input.replace(/[^0-9]/g, "");
    // if (input.length > maxLength) {
    //   return;
    // }
    if (index !== undefined) {
      setConsEditMultipleEmails(consEditMultipleEmails.map((prevEmails, locIndex) => {
        if (locIndex === index) {
          const updatedEmails = [...prevEmails]; // Copy the previous array
          updatedEmails[5] = input;  // Update index 3 with the new value
          return updatedEmails;                // Return the updated array
        }
        return prevEmails;                      // Return unchanged arrays for other indices
      }));
    }
    else {
      setMobileNumber(input);
    }
  };


  const handleReceiptsAdd = async (e) => {
    setIsModalOpen(true);
    await fetchCountryCodes(e);
  };

  const handleReceiptsFnLnEdit = async (e) => {
    ggEditorRemovedInPopupRef.current = false;
    // Fetch country codes
    await fetchCountryCodes(e);
    // Create a deep copy of consMultipleEmails

    let tempMultipleEmails = deepCopyArray(data.authorizedReaders);

    props.recipientPrintData?.forEach(printReader => {
      const index = tempMultipleEmails.findIndex(
        reader => reader[0]?.toLowerCase() === printReader[0]?.toLowerCase()
      );

      if (index !== -1) {
        tempMultipleEmails[index][7] = printReader[7];
        tempMultipleEmails[index][8] = printReader[8];
        tempMultipleEmails[index][9] = printReader[9];
      }
    });

    tempMultipleEmails.forEach((reader) => {
      if ((props.defaultCanPrint || canPrint || reader[7]) && reader[9] !== true) {
        reader[8] = props.defaultMaxPrintsPerReader;
      }
      if (reader[4]) {
        reader[4] = resolveCountryCode(reader[4]) || reader[4];
      }
    });
    // If tempMultipleEmails is empty or undefined, add only one empty row
    if (!tempMultipleEmails || tempMultipleEmails.length === 0) {
      tempMultipleEmails = [["", "", "", "", "", "", "", props.defaultCanPrint || false, props.defaultCanPrint ? props.defaultMaxPrintsPerReader : ""]]; // Array of empty values
    }
    // Set the state with the updated array
    setConsEditMultipleEmails(tempMultipleEmails);
    // Open the modal
    setIsModalFnLnEditOpen(true);
  };


  async function fetchCountryCodes() {
    try {
      const url = `${process.env.REACT_APP_API}/docs/GetAllCountryCodedes`;
      const response = await fetch(url);
      const data = await response.json();
      if (data != null) {
        const formattedOptions = [
          {
            value: "+Code", // Use an empty string or any value to represent "default"
            label: "+Code", // Placeholder text for the default option
            languageCode: "", // Optional: Add a default language code if needed
            mobileMaxLeng: 0, // Optional: Default value for max length
          },
          ...data.map((item) => ({
            value: `${item.dialCode}-${item.countryCode}`,
            label: `${item.countryName} (${item.dialCode})`,
            languageCode: item.countryCode.toLowerCase(), // Ensure lowercase
            mobileMaxLeng: item.mobileMaxLeng
          })),
        ];
        const transformedOptions = formattedOptions.map((option) => {
          if (option.value.includes('-') && option.value != "+Code") {
            const dialCode = option.value.split('-')[0];
            return {
              value: dialCode,
              label: option.label,
              languageCode: option.languageCode,
              mobileMaxLeng: option.mobileMaxLeng
            };
          }
          return option;
        });

        // Update the state with transformed options
        setCountryCodedrpOptions(transformedOptions);
        setCountryCodeOptions(formattedOptions);
        return { formattedOptions, transformedOptions };
      }
    } catch (error) {
      console.error('Error fetching country codes:', error);
    }
  }

  const handleReceiptsFnLnAdd = async (locEmail, fn, ln, verificationType, countryCode, mobileNum, reference, canPrintValue, maxPrintsPerReaderValue, fnLnIndex, isEdited) => {
    if (countryCode && countryCode.languageCode == 'ca') {
      const updatedOptions1 = countryCodeDrpOptions.map((option) => {
        // Check if the languageCode is "us", and if so, update the value
        if (option.languageCode != 'ca' || option.languageCode == '') {
          return { ...option, value: `${option.value.split('-')[0]}-${option.languageCode.toUpperCase()}` }; // Update value for US
        }
        // Leave other options unchanged
        return option;
      });

      setCountryCodeOptions(updatedOptions1);
    }
    if (countryCode && countryCode.languageCode == 'us') {
      const updatedOptions2 = countryCodeDrpOptions.map((option) => {
        // Check if the languageCode is "us", and if so, update the value
        if (option.languageCode != 'us' || option.languageCode == '') {
          return { ...option, value: `${option.value.split('-')[0]}-${option.languageCode.toUpperCase()}` }; // Update value for US
        }
        // Leave other options unchanged
        return option;
      });
      setCountryCodeOptions(updatedOptions2);
    }
    if (countryCodeOptions.length == 0) {
      await fetchCountryCodes();
    }
    setCurrentEmail(locEmail);
    setFirstName(fn);
    setLastName(ln);
    setReference(reference);
    setCurrentIndex(fnLnIndex);
    setIsModalFnLnOpen(true);
    setMobileNumber(mobileNum);
    setSelectedCode(resolveCountryCode(countryCode) || countryCode);
    setSelectVerificationCode(verificationType);
    setPrint((canPrintValue || props.defaultCanPrint) ? true : false);
    setMaxPrintsPerReaderText((canPrintValue || props.defaultCanPrint) ? (isEdited ? (maxPrintsPerReaderValue ?? "") : (props.defaultMaxPrintsPerReader ?? "")) : ""
    );

  };
  const handleCloseModal = () => {
    setIsModalOpen(false);
    resetUpload();
  };

  const handleCloseFnLnModal = () => {
    setIsModalFnLnOpen(false);
  };
  const handleCloseValidationModal = () => {
    setIsValidationPopup(false);
    setIsModalOpen(true);
    resetUpload();
  };

  let counter = 1;
  function DownloadReaderXLS(e) {
    let workbook = null;

    if (props.tabValue === "send") {
      // Add your actual headers
      const worksheet = XLSX.utils.aoa_to_sheet([
        [
          selectedLanguage.LstLanguageCodes.UI_EmailAdress,
          selectedLanguage.LstLanguageCodes.UI_FirstName,
          selectedLanguage.LstLanguageCodes.UI_LastName,
          selectedLanguage.LstLanguageCodes.UI_SendVerificationCodeTo,
          selectedLanguage.LstLanguageCodes.UI_CountryCode,
          selectedLanguage.LstLanguageCodes.UI_MobileNumber,
          selectedLanguage.LstLanguageCodes.UI_ReferenceTxt,
          selectedLanguage.LstLanguageCodes.UI_CanPrint,
          selectedLanguage.LstLanguageCodes.UI_MaxAllowedPrints,
          "",
          selectedLanguage.LstLanguageCodes.UI_MaxRecipientsCannotMoreThan99,
        ],
      ]);

      workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet 1");
    } else {
      const worksheet = XLSX.utils.aoa_to_sheet([
        [selectedLanguage.LstLanguageCodes.UI_EmailAdress, selectedLanguage.LstLanguageCodes.UI_FirstName, selectedLanguage.LstLanguageCodes.UI_LastName, selectedLanguage.LstLanguageCodes.UI_SendVerificationCodeTo, selectedLanguage.LstLanguageCodes.UI_CountryCode, selectedLanguage.LstLanguageCodes.UI_MobileNumber, selectedLanguage.LstLanguageCodes.UI_ReferenceTxt, selectedLanguage.LstLanguageCodes.UI_CanPrint, selectedLanguage.LstLanguageCodes.UI_MaxAllowedPrints,],
      ]);


      workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet 1");
    }

    const blob = XLSX.writeFile(workbook, "ReadersList.xlsx");

    saveAs(blob, "ReadersList.xls");
  }

  function DownloadReaderCSV(e) {
    let csvContent = [];

    if (props.tabValue === "send") {
      csvContent = [
        [
          selectedLanguage.LstLanguageCodes.UI_EmailAdress,
          selectedLanguage.LstLanguageCodes.UI_FirstName,
          selectedLanguage.LstLanguageCodes.UI_LastName,
          selectedLanguage.LstLanguageCodes.UI_SendVerificationCodeTo,
          selectedLanguage.LstLanguageCodes.UI_CountryCode,
          selectedLanguage.LstLanguageCodes.UI_MobileNumber,
          selectedLanguage.LstLanguageCodes.UI_ReferenceTxt,
          selectedLanguage.LstLanguageCodes.UI_CanPrint,
          selectedLanguage.LstLanguageCodes.UI_MaxAllowedPrints,
          "",
          '"' + selectedLanguage.LstLanguageCodes.UI_MaxRecipientsCannotMoreThan99 + '"',
        ],
      ];
    } else if (props.tabValue === "create") {
      csvContent = [[selectedLanguage.LstLanguageCodes.UI_EmailAdress, selectedLanguage.LstLanguageCodes.UI_FirstName, selectedLanguage.LstLanguageCodes.UI_LastName, selectedLanguage.LstLanguageCodes.UI_SendVerificationCodeTo, selectedLanguage.LstLanguageCodes.UI_CountryCode, selectedLanguage.LstLanguageCodes.UI_MobileNumber, selectedLanguage.LstLanguageCodes.UI_ReferenceTxt, selectedLanguage.LstLanguageCodes.UI_CanPrint, selectedLanguage.LstLanguageCodes.UI_MaxAllowedPrints,]];
    }
    //  csvContent.push("Email Address (Enter below)");

    downloadCSV(csvContent, "ReadersList.csv");
  }

  const resetUpload = () => {
    setSelectedFiles([]);
    setDuplicateEmails([]);
    setemailLeanghtValidation([]);
    setLongDomainEmails([]);
    setLongFirstName([]);
    setLongLastName([]);
    setInvalidEmailsWithoutDotComValidation([]);
    setLocalpartValiadation([]);
    setDuplicateInFile([]);
    setInvalidCanPrintValues([]);
    setExceedMaxPrintsPerDoc([]);
    setMaxPrintsWithoutCanPrint([]);
    setCanPrintNotEnabledAtDocLevel([]);
    setMaxPrintsExceedLimit([]);
    setInvalidMaxPrintsValues([]);
    setAlertMsg("");
    setAlertType("");
  };

  function downloadCSV(lstCsvRecipients, Download) {
    const safeCSVValue = (value) => {
      if (value == null || value === undefined) return "";

      const strValue = String(value);
      return `\t${strValue}`;
    };

    const csvRows = lstCsvRecipients.map((row) => {
      const values = typeof row === "string" ? row.split(",") : row;
      const sanitized = values.map(safeCSVValue);
      return sanitized.join(",");
    });

    const csvContent = "\uFEFF" + csvRows.join("\n");

    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const url = window.URL.createObjectURL(blob);

    const a = document.createElement("a");
    a.href = url;
    a.download = Download || "data.csv";
    a.click();

    window.URL.revokeObjectURL(url);
  }
  const [fileNames, setFileNames] = useState("");
  const [selectedFiles, setSelectedFiles] = useState([]);
  // var selectedFiles;
  function ReadersfileSelection(event) {
    if (event.target != undefined) {
      const newFiles = event.target.files;

      // Check if the selected file type is supported
      const supportedFileTypes = ["xls", "xlsx", "csv"];

      for (let index = 0; index < newFiles.length; index++) {
        const objFile = newFiles[index];

        if (
          !supportedFileTypes.includes(
            objFile.name.split(".").pop().toLowerCase()
          )
        ) {
          // document.getElementById("readersFile").value = null;

          // Display alert for incorrect file type
          setAlertMsg(
            selectedLanguage.LstLanguageCodes.UI_IncorrectFileType
          );
          setAlertType("warning");
          return;
        }
      }

      // Proceed with setting the new files
      setAlertMsg("");
      setAlertType("");
      const fileNames = Array.from(newFiles)
        .map((file) => file.name)
        .join(", ");
      setFileNames(fileNames);
      setSelectedFiles(newFiles);
      AddReadersInputFiled(newFiles);
    }
  }

  function ReadersfileSelectionClick(event) {
    event.target.value = null;
  }
  function AddReadersInputFiled(files, source = 0) {
    const arrayTemp = [];
    var index = 0;
    var validationFlag = false;
    if (ReadersinputFields.length > 0) {
      arrayTemp.push(...ReadersinputFields);
      index = ReadersinputFields.length;
      ReadersinputFields.some((oldfile) => {
        files.some((newfile) => {
          if (oldfile.orgFileName == newfile.name && validationFlag == false)
            validationFlag = true;
        });
      });
    }
    if (validationFlag == true) {
      setAlertMsg(
        selectedLanguage.LstLanguageCodes.UI_DuplicateFilesAreNotallowed
      );
      setAlertType("warning");
      return;
    }
  }

  const handleAddFnLn = () => {
    const emailVal = currentEmail.trim();
    if (props.defaultMaxPrintsPerDocument != "" && maxPrintsPerReaderText > props.defaultMaxPrintsPerDocument) {
      setAlertMsg(selectedLanguage.LstLanguageCodes.UI_Printsperreadercannotexceedprintspersdocument);
      setAlertType("warning");
      return;
    }
    const isDLRowInModal = Boolean(
      (props.contactGroups || []).some((g) => {
        if (!g) return false;
        const gName = (g.name || g.Name || g.groupName || g.GroupName || "").trim().toLowerCase();
        const gAlias = (g.aliasEmail || g.AliasEmail || g.email || g.Email || g.dlEmail || "").trim().toLowerCase();
        const targetKey = (emailVal || "").trim().toLowerCase();
        return (gAlias && gAlias === targetKey) || (gName && gName === targetKey) || (gAlias ? gAlias.split("@")[0] === targetKey : false);
      })
    );
    if (emailVal == "") {
      setAlertMsg(selectedLanguage.LstLanguageCodes.UI_Pleaseentervalidmail);
      setAlertType("warning");
      return;
    } else if (!isDLRowInModal && !/^[\w.\-]+@[a-zA-Z0-9.\-]+\.[a-zA-Z]{2,63}$/.test(emailVal)) {
      setAlertMsg(selectedLanguage.LstLanguageCodes.UI_Pleaseentervalidmail);
      setAlertType("warning");
      return;
    } else if (emailVal.split("@")[0].length > 64) {
      setAlertMsg(selectedLanguage.LstLanguageCodes.UI_LocalPartofEmailContainsMorethan64);
      setAlertType("warning");
      return;
    } else if (emailVal.length > 255) {
      setAlertMsg(selectedLanguage.LstLanguageCodes.UI_EmailAdressContainsMoreThan255);
      setAlertType("warning");
      return;
    }
    else if ((selectedCode == undefined || selectedCode == '') && (mobileNumber != '' && mobileNumber != undefined)) {
      setAlertMsg(selectedLanguage.LstLanguageCodes.UI_PleaseSelectCountryCode);
      setAlertType("warning");
      return;
    }
    else if ((selectedCode && (selectedCode.value == "+Code" || selectedCode.value == null)) && (mobileNumber != "" && mobileNumber != undefined)) {
      setAlertMsg(selectedLanguage.LstLanguageCodes.UI_PleaseSelectCountryCode);
      setAlertType("warning");
      return;
    } else if ((selectVerificationCode?.value === "text" || selectVerificationCode?.value === "both") && (!mobileNumber || mobileNumber.toString().trim() === "")) {
      setAlertMsg(selectedLanguage.LstLanguageCodes.UI_PleaseEnterMobileNumber);
      setAlertType("warning");
      return;
    } else if (selectedCode && mobileNumber && (selectedCode.mobileMaxLeng != mobileNumber.length)) {
      setAlertMsg(selectedLanguage.LstLanguageCodes.UI_PleaseEnterValidNumber);
      setAlertType("warning");
      return;
    }

    // Check if email or mobile number already exists in consMultipleEmails
    const rawTargetVal = (emailVal || '').trim().toLowerCase();
    const matchedGroupVal = (props.contactGroups || []).find((g) => {
      if (!g) return false;
      const gAlias = (g.aliasEmail || g.AliasEmail || g.email || g.Email || g.dlEmail || "").trim().toLowerCase();
      const gName = (g.name || g.Name || g.groupName || g.GroupName || "").trim().toLowerCase();
      const gAliasPrefix = gAlias ? gAlias.split("@")[0].toLowerCase() : "";
      return (gAlias && gAlias === rawTargetVal) || (gName && gName === rawTargetVal) || (gAliasPrefix && gAliasPrefix === rawTargetVal);
    });
    const canonicalEmailVal = (matchedGroupVal?.aliasEmail || matchedGroupVal?.AliasEmail || matchedGroupVal?.email || matchedGroupVal?.Email || rawTargetVal).trim().toLowerCase();

    const isDuplicateEmail = consMultipleEmails.some((emails, index) => {
      if (index === currentIndex) return false;
      const existingRaw = (emails[0] || "").trim().toLowerCase();
      const existingMatchedGroup = (props.contactGroups || []).find((g) => {
        if (!g) return false;
        const gAlias = (g.aliasEmail || g.AliasEmail || g.email || g.Email || g.dlEmail || "").trim().toLowerCase();
        const gName = (g.name || g.Name || g.groupName || g.GroupName || "").trim().toLowerCase();
        const gAliasPrefix = gAlias ? gAlias.split("@")[0].toLowerCase() : "";
        return (gAlias && gAlias === existingRaw) || (gName && gName === existingRaw) || (gAliasPrefix && gAliasPrefix === existingRaw);
      });
      const existingCanonical = (existingMatchedGroup?.aliasEmail || existingMatchedGroup?.AliasEmail || existingMatchedGroup?.email || existingMatchedGroup?.Email || existingRaw).trim().toLowerCase();
      return existingCanonical === canonicalEmailVal;
    });

    if (isDuplicateEmail) {
      setAlertMsg(selectedLanguage.LstLanguageCodes.UI_DuplicateEmailNotallowed);
      setAlertType("warning");
      return;
    }
    if (!matchedGroupVal && isEmailInEnteredDL(canonicalEmailVal, null, currentIndex)) {
      setAlertMsg(selectedLanguage?.LstLanguageCodes?.UI_EmailAlreadyExistsInGroup);
      setAlertType("warning");
      return;
    }

    const currentCountryCodeValue = selectedCode?.value ?? selectedCode ?? "";
    const isDuplicateMobile = consMultipleEmails.some((emails, index) => {
      if (index === currentIndex) return false;
      const existingMobile = emails[5] ?? "";
      const existingCountryCode = emails[4]?.value ?? emails[4] ?? "";
      return (
        existingMobile !== "" &&
        mobileNumber !== "" &&
        existingMobile === mobileNumber &&
        existingCountryCode === currentCountryCodeValue
      );
    });

    if (isDuplicateMobile) {
      setAlertMsg(selectedLanguage.LstLanguageCodes.UI_DuplicateMobileNum);
      setAlertType("warning");
      return;
    }
    if (firstName.trim().length > 50) {
      setAlertMsg(selectedLanguage.LstLanguageCodes.UI_FirstNameMoreThanFifty);
      setAlertType("warning");
      return;
    } else if (lastName.trim().length > 50) {
      setAlertMsg(selectedLanguage.LstLanguageCodes.UI_LastNameMoreThanFifty);
      setAlertType("warning");
      return;
    } else if (reference && reference.trim().length > 50) {
      setAlertMsg(selectedLanguage.LstLanguageCodes.UI_ReferenceMoreThanFifty);
      setAlertType("warning");
      return;
    }

    var arrayTemp = deepCopyArray(data.authorizedReaders);
    props.recipientPrintData.forEach(printReader => {
      const index = arrayTemp.findIndex(
        reader => reader[0]?.toLowerCase() === printReader[0]?.toLowerCase()
      );

      if (index !== -1) {
        const updated = [...arrayTemp[index]];
        updated[7] = printReader[7];
        updated[8] = printReader[8];
        updated[9] = printReader[9];
        arrayTemp[index] = updated;
      }
    });
    arrayTemp = arrayTemp.map((emails, index) => {
      if (index == currentIndex) {
        const trimmedEmail = (emailVal || '').trim();
        const lowerEmail = trimmedEmail.toLowerCase();
        const matchedGroup = (props.contactGroups || []).find((g) => {
          if (!g) return false;
          const gName = (g.name || g.Name || g.groupName || g.GroupName || "").trim().toLowerCase();
          const gAlias = (g.aliasEmail || g.AliasEmail || g.email || g.Email || g.dlEmail || "").trim().toLowerCase();
          return (gAlias && gAlias === lowerEmail) || (gName && gName === lowerEmail);
        });

        let finalEmail = trimmedEmail;
        let finalFn = (firstName || '').trim();
        let finalLn = (lastName || '').trim();
        let isDLGroup = matchedGroup ? true : Boolean(emails[10]);
        let groupObj = matchedGroup || emails[11] || null;

        if (matchedGroup) {
          finalEmail = matchedGroup.aliasEmail || matchedGroup.AliasEmail || matchedGroup.email || matchedGroup.Email || matchedGroup.name || matchedGroup.Name || trimmedEmail;
          finalFn = matchedGroup.name || matchedGroup.Name || matchedGroup.groupName || matchedGroup.GroupName || "Distribution List";
          finalLn = "(DL)";
        }

        return [
          finalEmail,
          finalFn,
          finalLn,
          selectVerificationCode,
          isDLGroup ? "" : selectedCode,
          isDLGroup ? "" : mobileNumber,
          isDLGroup ? "" : (reference || '').trim(),
          canPrint,
          maxPrintsPerReaderText,
          true,
          isDLGroup,
          groupObj
        ];
      }
      return emails;
    });
    if (props.onRecipientPrintDataUpdate) {
      props.onRecipientPrintDataUpdate(deepCopyArray(arrayTemp));
    }
    dispatch(retainConfiguredData({ ...data, authorizedReaders: arrayTemp }));
    setConsMultipleEmails(arrayTemp);
    props.recipientDetailsFromChaild(arrayTemp);
    setIsModalFnLnOpen(false);
  };

  var jsonData;
  var lines;

  const parseXLSXcreate = async (file) => {
    try {
      const data = await file.arrayBuffer();
      const wb = XLSX.read(data, { type: "array" });
      const ws = wb.Sheets[wb.SheetNames[0]];
      const jsonData = XLSX.utils.sheet_to_json(ws, {
        header: 1,
        raw: false,
      });

      const emails = jsonData
        .slice(1) // Skip header row
        .map((row) => {
          const emailValue = row[0]; // Email
          const fnValue = row[1]; // First name
          const lnValue = row[2]; // Last name
          const countryCodeValue = row[4]; // Country code
          const mobileNumberValue = row[5]; // Mobile number
          const verificationTypeValue = row[3]?.toLowerCase(); // Verification Type
          const reference = row[6]; // Reference
          const canPrintRaw = row[7] != null ? String(row[7]).trim() : ""; // CanPrint
          const maxPrintsRaw = row[8] != null ? String(row[8]).trim() : ""; // MaxAllowedPrints
          const trimmedEmail =
            typeof emailValue === "string" ? emailValue.trim().toLowerCase() : null;
          const trimmedFn = typeof fnValue === "string" ? fnValue.trim() : "";
          const trimmedLn = typeof lnValue === "string" ? lnValue.trim() : "";
          const trimmedCountryCode =
            typeof countryCodeValue === "string" ? countryCodeValue.trim() : "";
          const trimmedMobileNumber =
            typeof mobileNumberValue === "string" ? mobileNumberValue.trim() : "";
          const trimmedReference =
            typeof reference === "string" ? reference.trim() : "";
          const trimmedVerificationType =
            typeof verificationTypeValue !== "" ? VerificationOptionsForFilter.find((opt => opt.value == verificationTypeValue)) : verificationTypeValue;
          const verificationType = trimmedVerificationType ? trimmedVerificationType : verificationTypeValue;
          const countryCodeDetailsObj =
            trimmedCountryCode != "" ? (resolveCountryCode(trimmedCountryCode) || countryCodeDrpOptions.find((cc) => cc.value === trimmedCountryCode) || trimmedCountryCode) : [];

          const validCanPrintLookup = ["true", "yes", "1"];
          const validCanPrintAll = ["", "true", "false", "yes", "no", "1", "0"];
          const isValidCanPrint = validCanPrintAll.includes(canPrintRaw.toLowerCase());
          const parsedCanPrint = canPrintRaw !== ""
            ? (validCanPrintLookup.includes(canPrintRaw.toLowerCase()) ? true : (props.defaultCanPrint || false))
            : (props.defaultCanPrint || false);
          const isValidMaxPrints = maxPrintsRaw === "" || /^\d+$/.test(maxPrintsRaw);
          const parsedMaxPrints = maxPrintsRaw !== ""
            ? (isValidMaxPrints ? (parseInt(maxPrintsRaw, 10) || "") : "")
            : (parsedCanPrint ? props.defaultMaxPrintsPerReader : "");
          const isMaxPrintsEdited = maxPrintsRaw !== "";

          const rowArr = [
            trimmedEmail,
            trimmedFn,
            trimmedLn,
            verificationType,
            countryCodeDetailsObj,
            trimmedMobileNumber,
            trimmedReference,
            parsedCanPrint,
            parsedMaxPrints,
            isMaxPrintsEdited
          ];
          if (!isValidCanPrint && canPrintRaw !== "") {
            rowArr.invalidCanPrint = canPrintRaw;
          }
          if (!isValidMaxPrints) {
            rowArr.invalidMaxPrints = maxPrintsRaw;
          }
          return rowArr;
        })
        .filter((email) => email[0] !== null); // Filter out null values for emails

      return emails;
    } catch (error) {
      console.error("Error parsing XLSX file:", error);
      return [];
    }
  };


  const handleFileChange = () => {
    var duplicateCount = 0;
    if (!selectedFiles || selectedFiles.length === 0) {
      setAlertMsg(selectedLanguage.LstLanguageCodes.UI_PleaseSelectFileUpload);
      setAlertType("warning");
    }
    const file = selectedFiles[0];
    const reader = new FileReader();
    reader.onload = async (e) => {
      const fileData = e.target.result;
      const fileExtension = file.name.split(".").pop().toLowerCase();
      let validationPopupFlag = false;
      if (fileExtension === "csv") {
        var emailsFromFile = parseCSVcreate(fileData);
      } else if (fileExtension === "xlsx") {
        var emailsFromFile = await parseXLSXcreate(file);
      } else {
        console.error("Unsupported file type");
        return;
      }
      resetUpload();

      emailsFromFile = (emailsFromFile || []).map((row) => {
        if (!row || !row[0]) return row;
        const rawE = String(row[0]).trim().toLowerCase();
        const matchedG = (props.contactGroups || []).find((g) => {
          if (!g) return false;
          const gAlias = (g.aliasEmail || g.AliasEmail || g.email || g.Email || g.dlEmail || "").trim().toLowerCase();
          const gName = (g.name || g.Name || g.groupName || g.GroupName || "").trim().toLowerCase();
          const gAliasPrefix = gAlias ? gAlias.split("@")[0].toLowerCase() : "";
          return (gAlias && gAlias === rawE) || (gName && gName === rawE) || (gAliasPrefix && gAliasPrefix === rawE);
        });
        const matchedC = !matchedG ? (props.contacts || []).find((c) => {
          if (!c) return false;
          const cEmail = (c.email || c.Email || "").trim().toLowerCase();
          return cEmail && cEmail === rawE;
        }) : null;

        let updatedRow = [...row];
        if (matchedG) {
          updatedRow[0] = matchedG.aliasEmail || matchedG.AliasEmail || matchedG.email || matchedG.Email || matchedG.name || matchedG.Name || row[0];
          updatedRow[1] = matchedG.name || matchedG.Name || matchedG.groupName || matchedG.GroupName || "Distribution List";
          updatedRow[2] = "(DL)";
          updatedRow[10] = true;
          updatedRow[11] = matchedG;
        } else if (matchedC) {
          updatedRow[0] = matchedC.email || matchedC.Email || row[0];
          updatedRow[1] = (updatedRow[1] && updatedRow[1].trim() !== "") ? updatedRow[1] : (matchedC.firstName || matchedC.FirstName || "");
          updatedRow[2] = (updatedRow[2] && updatedRow[2].trim() !== "") ? updatedRow[2] : (matchedC.lastName || matchedC.LastName || "");
          const rawCC = (updatedRow[4] && (typeof updatedRow[4] === "string" ? updatedRow[4].trim() : updatedRow[4]?.value)) || matchedC.phoneCode || matchedC.PhoneCode || "";
          const resolvedCC = resolveCountryCode(rawCC);
          updatedRow[4] = resolvedCC || (rawCC ? { value: rawCC, label: rawCC } : "");
          updatedRow[5] = (updatedRow[5] && String(updatedRow[5]).trim() !== "") ? updatedRow[5] : (matchedC.mobile || matchedC.Mobile || "");
          updatedRow[6] = (updatedRow[6] && String(updatedRow[6]).trim() !== "") ? updatedRow[6] : (matchedC.referenceTag || matchedC.ReferenceTag || "");
        } else if (updatedRow[4]) {
          updatedRow[4] = resolveCountryCode(updatedRow[4]) || updatedRow[4];
        }
        return updatedRow;
      });
      const multipleEmailVar = [];
      let emailSet = new Set();
      const mergedEmails = [...data.authorizedReaders, ...emailsFromFile];
      mergedEmails.forEach((emailFromFile) => {
        if (!emailFromFile) return;
        let clonedRow = [...emailFromFile];
        let rawEmail = clonedRow[0];

        if (rawEmail !== null && rawEmail !== undefined && typeof rawEmail === 'string' && rawEmail.trim() !== "") {
          const rawTarget = rawEmail.trim().toLowerCase();
          const matchedGroup = (props.contactGroups || []).find((g) => {
            if (!g) return false;
            const gAlias = (g.aliasEmail || g.AliasEmail || g.email || g.Email || g.dlEmail || "").trim().toLowerCase();
            const gName = (g.name || g.Name || g.groupName || g.GroupName || "").trim().toLowerCase();
            const gAliasPrefix = gAlias ? gAlias.split("@")[0].toLowerCase() : "";
            return (gAlias && gAlias === rawTarget) || (gName && gName === rawTarget) || (gAliasPrefix && gAliasPrefix === rawTarget);
          });
          const matchedContact = !matchedGroup ? (props.contacts || []).find((c) => {
            if (!c) return false;
            const cEmail = (c.email || c.Email || "").trim().toLowerCase();
            return cEmail && cEmail === rawTarget;
          }) : null;

          const canonicalEmail = (
            matchedGroup ? (matchedGroup.aliasEmail || matchedGroup.AliasEmail || matchedGroup.email || matchedGroup.Email || matchedGroup.dlEmail || matchedGroup.name || matchedGroup.Name || rawTarget) :
              matchedContact ? (matchedContact.email || matchedContact.Email || rawTarget) :
                rawTarget
          ).trim().toLowerCase();

          if (matchedGroup) {
            clonedRow[0] = matchedGroup.aliasEmail || matchedGroup.AliasEmail || matchedGroup.email || matchedGroup.Email || matchedGroup.name || matchedGroup.Name || rawEmail.trim();
            clonedRow[1] = matchedGroup.name || matchedGroup.Name || matchedGroup.groupName || matchedGroup.GroupName || "Distribution List";
            clonedRow[2] = "(DL)";
            clonedRow[10] = true;
            clonedRow[11] = matchedGroup;
          } else if (matchedContact) {
            clonedRow[0] = matchedContact.email || matchedContact.Email || rawEmail.trim();
            clonedRow[1] = (clonedRow[1] && clonedRow[1].trim() !== "") ? clonedRow[1] : (matchedContact.firstName || matchedContact.FirstName || "");
            clonedRow[2] = (clonedRow[2] && clonedRow[2].trim() !== "") ? clonedRow[2] : (matchedContact.lastName || matchedContact.LastName || "");
            const rawCC = (clonedRow[4] && (typeof clonedRow[4] === "string" ? clonedRow[4].trim() : clonedRow[4]?.value)) || matchedContact.phoneCode || matchedContact.PhoneCode || "";
            const resolvedCC = resolveCountryCode(rawCC);
            clonedRow[4] = resolvedCC || (rawCC ? { value: rawCC, label: rawCC } : "");
            clonedRow[5] = (clonedRow[5] && String(clonedRow[5]).trim() !== "") ? clonedRow[5] : (matchedContact.mobile || matchedContact.Mobile || "");
            clonedRow[6] = (clonedRow[6] && String(clonedRow[6]).trim() !== "") ? clonedRow[6] : (matchedContact.referenceTag || matchedContact.ReferenceTag || "");
          } else if (clonedRow[4]) {
            clonedRow[4] = resolveCountryCode(clonedRow[4]) || clonedRow[4];
          }

          if (!emailSet.has(canonicalEmail)) {
            multipleEmailVar.push(clonedRow);
            emailSet.add(canonicalEmail);
          } else {
            duplicateCount++;
          }
        }
      });

      // Check if any email from bulk import already exists in an entered DL
      const hasEmailInDL = multipleEmailVar.some((row, idx) => {
        if (!row || !row[0]) return false;
        if (row[10] === true || row[2] === "(DL)" || row[2] === "(Distribution List)") return false;
        return isEmailInEnteredDL(row[0], multipleEmailVar, idx);
      });

      if (hasEmailInDL) {
        setAlertMsg(selectedLanguage?.LstLanguageCodes?.UI_EmailAlreadyExistsInGroup);
        setAlertType("warning");
        setSelectedFiles([]);
        return;
      }

      if (props.tabValue === "send") {
        if (mergedEmails.length > 99) {
          setConstMultipleEmails([]);
          setAlertMsg(
            selectedLanguage.LstLanguageCodes.UI_MaxRecipientsCannotMoreThan99
          );
          setAlertType("warning");
          return;
        }
      }

      const specificText = selectedLanguage.LstLanguageCodes.UI_EmailAdress;
      const specificFn = selectedLanguage.LstLanguageCodes.UI_FirstName;
      const specificLn = selectedLanguage.LstLanguageCodes.UI_LastName;
      let containsSpecificTextXLS;
      if (fileExtension === "xlsx") {
        if (jsonData) {
          containsSpecificTextXLS = jsonData.some((row) =>
            row.includes(specificText)
          );
          if (containsSpecificTextXLS == true) {
            containsSpecificTextXLS = jsonData.some((row) =>
              row.includes(specificFn)
            );
          }
          if (containsSpecificTextXLS == true) {
            containsSpecificTextXLS = jsonData.some((row) =>
              row.includes(specificLn)
            );
          }
        }
        if (props.tabValue === "create" && (!containsSpecificTextXLS && jsonData)) {
          setAlertMsg(selectedLanguage.LstLanguageCodes.UI_PleaseEnterValidFile);
          setAlertType("warning");
          setSelectedFiles([]);
          return;
        } else if (props.tabValue === "send" && (!containsSpecificTextXLS && jsonData)) {
          setAlertMsg(selectedLanguage.LstLanguageCodes.UI_PleaseEnterValidFile);
          setAlertType("warning");
          setSelectedFiles([]);
          return;
        }
      }



      if (fileExtension === "csv") {
        if (props.tabValue === "send") {
          let containsSpecificTextCSV = lines.some((row) =>
            row.includes(specificText)
          );
          if (containsSpecificTextCSV == true) {
            containsSpecificTextCSV = lines.some((row) =>
              row.includes(specificFn)
            );
          }
          if (containsSpecificTextCSV == true) {
            containsSpecificTextCSV = lines.some((row) =>
              row.includes(specificLn)
            );
          }
          if (!containsSpecificTextCSV) {
            setAlertMsg(selectedLanguage.LstLanguageCodes.UI_PleaseEnterValidFile);
            setAlertType("warning");
            setSelectedFiles([]);
            return;
          }
        }
        if (props.tabValue === "create") {
          let containsSpecificTextCSVcreate = lines.some((row) =>
            row.includes(specificText)
          );
          if (containsSpecificTextCSVcreate == true) {
            containsSpecificTextCSVcreate = lines.some((row) =>
              row.includes(specificFn)
            );
          }
          if (containsSpecificTextCSVcreate == true) {
            containsSpecificTextCSVcreate = lines.some((row) =>
              row.includes(specificLn)
            );
          }
          if (!containsSpecificTextCSVcreate) {
            setAlertMsg(selectedLanguage.LstLanguageCodes.UI_PleaseEnterValidFile);
            setAlertType("warning");
            setSelectedFiles([]);
            return;
          }
        }
      }
      if (emailsFromFile.length === 0) {
        setAlertMsg(selectedLanguage.LstLanguageCodes.UI_EmailAdressCannotBeEmpty);
        setAlertType("warning");
        validationPopupFlag = true;
        setSelectedFiles([]);
        return;
      }
      multipleEmailVar.forEach((email) => {
        if (email && email[0]) {
          email[0] = email[0].trim();
        }
      });
      const isDLRowCheck = (emailArr) => Boolean(
        emailArr[10] === true ||
        emailArr.isGroup ||
        emailArr.isDLGroup ||
        emailArr[2] === "(DL)" ||
        (props.contactGroups || []).some((g) => {
          if (!g) return false;
          const gName = (g.name || g.Name || g.groupName || g.GroupName || "").trim().toLowerCase();
          const gAlias = (g.aliasEmail || g.AliasEmail || g.email || g.Email || g.dlEmail || "").trim().toLowerCase();
          const targetKey = (emailArr[0] || "").trim().toLowerCase();
          return (gAlias && gAlias === targetKey) || (gName && gName === targetKey) || (gAlias ? gAlias.split("@")[0] === targetKey : false);
        })
      );

      const emailLeanghtValidation = multipleEmailVar.filter(
        (email) => !isDLRowCheck(email) && email[0].length > 255
      );
      if (emailLeanghtValidation.length > 0) {
        setemailLeanghtValidation(emailLeanghtValidation);
        setIsValidationPopup(true);
        setLongDomainEmails([]);
        setLocalpartValiadation([]);
        duplicateCount = 0;
        validationPopupFlag = true;
      } else if (validationPopupFlag == false) {
        setIsValidationPopup(false);
      }
      const longDomainEmails = multipleEmailVar.filter((email) => {
        if (isDLRowCheck(email)) return false;
        const domain = email[0].split("@")[1];
        return domain && domain.length > 190;
      });
      if (longDomainEmails.length > 0) {
        setLongDomainEmails(longDomainEmails);
        setIsValidationPopup(true);
        validationPopupFlag = true;
        duplicateCount = 0;
      } else if (validationPopupFlag == false) {
        setIsValidationPopup(false);
        setLongDomainEmails([]);
      }
      const longReference = multipleEmailVar.filter((email) => {
        return email[6] && email[6].trim().length > 50;
      });
      if (longReference.length > 0) {
        setLongReference(longReference);
        setIsValidationPopup(true);
        validationPopupFlag = true;
        duplicateCount = 0;
      } else if (validationPopupFlag == false) {
        setIsValidationPopup(false);
      }
      const longFirstName = multipleEmailVar.filter((email) => {
        return email[1] && email[1].trim().length > 50;
      });
      if (longFirstName.length > 0) {
        setLongFirstName(longFirstName);
        setIsValidationPopup(true);

        duplicateCount = 0;
        validationPopupFlag = true;
      } else if (validationPopupFlag == false) {
        setIsValidationPopup(false);
        setLongFirstName([]);
      }
      const longLastName = multipleEmailVar.filter((email) => {
        return email[2] && email[2].trim().length > 50;
      });
      if (longLastName.length > 0) {
        setLongLastName(longLastName);
        setIsValidationPopup(true);
        validationPopupFlag = true;

        duplicateCount = 0;
      } else if (validationPopupFlag == false) {
        setIsValidationPopup(false);
      }

      const invalidEmailsWithoutDotCom = multipleEmailVar.filter(
        (email) =>
          !isDLRowCheck(email) &&
          email[0].trim() !== "" &&
          !/^[\w\.\-]+@[a-zA-Z0-9\.\-]+\.[a-zA-Z]{2,63}$/.test(email[0])
      );
      if (invalidEmailsWithoutDotCom.length > 0) {
        setInvalidEmailsWithoutDotComValidation(invalidEmailsWithoutDotCom);
        setIsValidationPopup(true);
        validationPopupFlag = true;
        duplicateCount = 0;
      } else if (validationPopupFlag == false) {
        setIsValidationPopup(false);
      }

      const invalidLocalPart = multipleEmailVar.filter(
        (email) => !isDLRowCheck(email) && email[0].split("@")[0].length > 64
      );
      if (invalidLocalPart.length > 0) {
        setLocalpartValiadation(invalidLocalPart);
        setIsValidationPopup(true);
        validationPopupFlag = true;
        duplicateCount = 0;
      } else if (validationPopupFlag == false) {
        setIsValidationPopup(false);
      }
      const countryDialCodes = countryCodeDrpOptions.map((option) => option.value);

      const unauthorizedCountryCodes = emailsFromFile.filter((email) => {
        const countryCode = email[4];
        let countryCodeVlaue = "";
        if (countryCode?.value) {
          // Assign trimmed value from the `value` property
          countryCodeVlaue = countryCode.value.trim();
        } else {
          // Assign countryCode directly if `value` property is not present
          countryCodeVlaue = countryCode;
        }
        if (countryCodeVlaue.length == 0) {
          return false;
        }
        return countryCodeVlaue && !countryDialCodes.includes(countryCodeVlaue);
      });

      if (unauthorizedCountryCodes.length > 0) {
        setUnauthorizedCountryCodes(unauthorizedCountryCodes);
        setIsValidationPopup(true);
        validationPopupFlag = true;
        duplicateCount = 0;
      } else {
        // setIsValidationPopup(false);
        setUnauthorizedCountryCodes([]);
      }


      const countryDialCodeMap = countryCodeDrpOptions.reduce((acc, option) => {
        acc[option.value] = option.mobileMaxLeng; // Example: { "+1": 10, "+91": 10 }
        return acc;
      }, {});

      // Validate mobile numbers against country codes
      const invalidMobileNumbers = emailsFromFile.filter((email) => {
        const countryCode = email[4];
        let countryCodeVlaue = "";
        if (countryCode?.value) {
          countryCodeVlaue = countryCode.value.trim();
        } else {
          countryCodeVlaue = countryCode;
        }
        const mobileNumber = email[5]?.trim();
        const maxLength = countryDialCodeMap[countryCodeVlaue];
        const onlyDigits = /^\d+$/;
        return (
          maxLength &&
          mobileNumber &&
          (mobileNumber.length !== maxLength || !onlyDigits.test(mobileNumber))
        );
      });


      if (invalidMobileNumbers.length > 0) {
        setInvalidMobileNumbers(invalidMobileNumbers);
        setIsValidationPopup(true);
        validationPopupFlag = true;
        duplicateCount = 0;
      } else {
        // setIsValidationPopup(false);
        setInvalidMobileNumbers([]);
      }

      const mobileNumberSet = new Set();
      const duplicateMobileNumbers = [];

      // Filter for duplicate mobile numbers
      const duplicateMobileNumberRows = multipleEmailVar.filter((email) => {
        const mobileNumber = email[5]?.trim();
        const countryCode = email[4]?.value ?? email[4] ?? "";
        const compositeKey = `${countryCode}-${mobileNumber}`;
        if (mobileNumber && mobileNumberSet.has(compositeKey)) {
          duplicateMobileNumbers.push(email);
          return true;
        } else {
          if (mobileNumber) mobileNumberSet.add(compositeKey);
          return false;
        }
      });

      if (duplicateMobileNumberRows.length > 0) {
        setDuplicateMobileNumbers(duplicateMobileNumbers);
        setIsValidationPopup(true);
        validationPopupFlag = true;
        duplicateCount = 0;
      } else {
        // setIsValidationPopup(false);
        setDuplicateMobileNumbers([]);
      }


      // Check for missing mobile numbers when a country code is provided
      const missingMobileNumbers = [];

      // Check for missing mobile numbers when a country code is provided
      const rowsWithMissingMobileNumbers = emailsFromFile.filter((email) => {
        const countryCode = email[4];
        let countryCodeVlaue = "";
        if (countryCode?.value) {
          // Assign trimmed value from the `value` property
          countryCodeVlaue = countryCode.value.trim();
        } else {
          // Assign countryCode directly if `value` property is not present
          countryCodeVlaue = countryCode;
        }
        const mobileNumber = email[5]?.trim();

        if (countryCodeVlaue.length != 0 && !mobileNumber) {
          missingMobileNumbers.push(email);
          return true;
        }
        return false;
      });

      if (rowsWithMissingMobileNumbers.length > 0) {
        setMissingMobileNumbers(missingMobileNumbers);
        setIsValidationPopup(true);
        validationPopupFlag = true;
        duplicateCount = 0;
      } else {
        setMissingMobileNumbers([]);
      }

      const invalidOptionsFromVerification = multipleEmailVar.filter((email) => {
        const verificationType = email[3];

        // Check only when verificationType exists
        if (verificationType && typeof verificationType === 'object' && verificationType.value) {
          const validValues = ["text", "email", "both"];
          return !validValues.includes(verificationType.value.toLowerCase());
        } else if (verificationType && typeof verificationType === 'string') {
          const validValues = ["text", "email", "both"];
          return !validValues.includes(verificationType.toLowerCase());
        }

        return false;
      });

      if (invalidOptionsFromVerification.length > 0) {
        setInvalidOption(invalidOptionsFromVerification);
        setIsValidationPopup(true);
        validationPopupFlag = true;
        duplicateCount = 0;
      } else {
        setInvalidOption([]);
      }

      const missingCountryCodes = [];

      const textNotEnabledMsg = emailsFromFile.filter((email) => {
        const verificationType = email[3];
        const textSelected = props.selectedOptions && props.selectedOptions.map((opt) => opt.value == "text");
        const emailSelected = props.selectedOptions && props.selectedOptions.map((opt) => opt.value == "email");
        if (verificationType && verificationType.value == "text" && !textSelected.includes(true)) {
          return true;
        }
        return false;
      });
      if (textNotEnabledMsg.length > 0) {
        setTextIsNotEnabled(textNotEnabledMsg);
        setIsValidationPopup(true);
        validationPopupFlag = true;
        duplicateCount = 0;
      } else {
        setTextIsNotEnabled([]);
      }
      const emailIsNotEnabledmsg = emailsFromFile.filter((email) => {
        const verificationType = email[3];
        const textSelected = props.selectedOptions && props.selectedOptions.map((opt) => opt.value == "text");
        const emailSelected = props.selectedOptions && props.selectedOptions.map((opt) => opt.value == "email");
        if (verificationType && verificationType.value == "email" && !emailSelected.includes(true)) {
          return true;
        }
        return false;
      });
      if (emailIsNotEnabledmsg.length > 0) {
        setEmailIsNotEnabled(emailIsNotEnabledmsg);
        setIsValidationPopup(true);
        validationPopupFlag = true;
        duplicateCount = 0;
      } else {
        setEmailIsNotEnabled([]);
      }
      const bothNotEnabledMsg = emailsFromFile.filter((email) => {
        const verificationType = email[3];
        const textSelected = props.selectedOptions?.some((opt) => opt.value == "text");
        const emailSelected = props.selectedOptions?.some((opt) => opt.value == "email");

        if (verificationType && verificationType.value == "both") {
          if (textSelected && !emailSelected) {
            email.errorMessage = selectedLanguage.LstLanguageCodes.UI_PleaseEnterEmail;
            return true;
          }
          if (emailSelected && !textSelected) {
            email.errorMessage = selectedLanguage.LstLanguageCodes.UI_PleaseEnterText;
            return true;
          }
        }
        return false;
      });
      if (bothNotEnabledMsg.length > 0) {
        setBothIsNotEnabled(bothNotEnabledMsg);
        setIsValidationPopup(true);
        validationPopupFlag = true;
        duplicateCount = 0;
      } else {
        setBothIsNotEnabled([]);
      }

      const invalidCanPrintRows = multipleEmailVar.filter((email) => email.invalidCanPrint);
      if (invalidCanPrintRows.length > 0) {
        setInvalidCanPrintValues(invalidCanPrintRows);
        setIsValidationPopup(true);
        validationPopupFlag = true;
        duplicateCount = 0;
      } else {
        setInvalidCanPrintValues([]);
      }

      const exceedMaxPrintsRows = multipleEmailVar.filter((email) => {
        return props.defaultMaxPrintsPerDocument !== "" &&
          props.defaultMaxPrintsPerDocument != null &&
          email[7] === true &&
          email[8] !== "" &&
          email[8] != null &&
          parseInt(email[8]) > parseInt(props.defaultMaxPrintsPerDocument);
      });
      if (exceedMaxPrintsRows.length > 0) {
        setExceedMaxPrintsPerDoc(exceedMaxPrintsRows);
        setIsValidationPopup(true);
        validationPopupFlag = true;
        duplicateCount = 0;
      } else {
        setExceedMaxPrintsPerDoc([]);
      }

      const maxPrintsWithoutCanPrintRows = props.docLevelCanPrint
        ? multipleEmailVar.filter((email) => {
          return email[7] !== true &&
            email[8] !== "" &&
            email[8] != null;
        })
        : [];
      if (maxPrintsWithoutCanPrintRows.length > 0) {
        setMaxPrintsWithoutCanPrint(maxPrintsWithoutCanPrintRows);
        setIsValidationPopup(true);
        validationPopupFlag = true;
        duplicateCount = 0;
      } else {
        setMaxPrintsWithoutCanPrint([]);
      }

      const canPrintNotEnabledAtDocLevelRows = !props.docLevelCanPrint
        ? multipleEmailVar.filter((email) => {
          return email[7] === true || (email[8] !== "" && email[8] != null);
        })
        : [];
      if (canPrintNotEnabledAtDocLevelRows.length > 0) {
        setCanPrintNotEnabledAtDocLevel(canPrintNotEnabledAtDocLevelRows);
        setIsValidationPopup(true);
        validationPopupFlag = true;
        duplicateCount = 0;
      } else {
        setCanPrintNotEnabledAtDocLevel([]);
      }

      const maxPrintsExceedLimitRows = multipleEmailVar.filter((email) => {
        return email[8] !== "" && email[8] != null && parseInt(email[8]) > 9999;
      });
      if (maxPrintsExceedLimitRows.length > 0) {
        setMaxPrintsExceedLimit(maxPrintsExceedLimitRows);
        setIsValidationPopup(true);
        validationPopupFlag = true;
        duplicateCount = 0;
      } else {
        setMaxPrintsExceedLimit([]);
      }

      const invalidMaxPrintsRows = multipleEmailVar.filter((email) => email.invalidMaxPrints != null);
      if (invalidMaxPrintsRows.length > 0) {
        setInvalidMaxPrintsValues(invalidMaxPrintsRows);
        setIsValidationPopup(true);
        validationPopupFlag = true;
        duplicateCount = 0;
      } else {
        setInvalidMaxPrintsValues([]);
      }

      const selectedValues = props.selectedOptions?.map((opt) => opt.value) || [];

      // const invalidRecipients = emailsFromFile.filter((email) => {
      //   const verificationType = email[5];
      //   if (!verificationType) return false;

      //   // If the recipient’s verification type is not in selected dropdown values → invalid
      //   return !selectedValues.includes(verificationType.value);
      // });

      // if (invalidRecipients.length > 0) {
      //   setAlertMsg("One or more recipients have a passcode type not selected in dropdown.");
      //   setAlertType("warning");
      //   return;
      // }
      // Check for missing country codes when a mobile number is provided
      const rowsWithMissingCountryCodes = emailsFromFile.filter((email) => {
        const countryCode = email[4];
        let countryCodeVlaue = "";
        if (countryCode?.value) {
          countryCodeVlaue = countryCode.value.trim();
        } else {
          countryCodeVlaue = countryCode;
        }
        const mobileNumber = email[5]?.trim();

        if (countryCodeVlaue.length == 0 && mobileNumber) {
          missingCountryCodes.push(email);
          return true;
        }
        return false;
      });

      if (rowsWithMissingCountryCodes.length > 0) {
        setMissingCountryCodes(missingCountryCodes);
        setIsValidationPopup(true);
        validationPopupFlag = true;
        duplicateCount = 0;
      } else {
        // setIsValidationPopup(false);
        setMissingCountryCodes([]);
      }

      if (!validationPopupFlag) {
        setConsMultipleEmails(multipleEmailVar);
        props.recipientDetailsFromChaild(multipleEmailVar);
        resetUpload();
      }
      if (duplicateCount > 0) {
        setAlertMsg(duplicateCount + " " + selectedLanguage.LstLanguageCodes.UI_DeDuplicateMsg)
        setAlertType("warning");
      }
    };

    reader.readAsText(file);
    setIsModalOpen(false);
    setFileNames("");
    // setPlaceholderText("");
  };
  const parseCSVcreate = (fileData) => {
    lines = fileData.split("\n");
    const emails = lines
      .slice(1) // Skip the first line (header)
      .map((line) => {
        const values = line.split(",");

        const emailValue = values[0]; // Email
        const fnValue = values.length > 1 ? values[1] : ""; // First Name
        const lnValue = values.length > 2 ? values[2] : ""; // Last Name
        const selectVerificationCode = values.length > 3 ? values[3]?.toLowerCase() : ""; // Send Verification Code to
        const countryCode = values.length > 4 ? values[4] : ""; // Country Code
        const mobileNumber = values.length > 5 ? values[5] : ""; // Mobile Number
        const reference = values.length > 6 ? values[6] : ""; // Reference
        const canPrintRaw = values.length > 7 ? (values[7] ? values[7].trim() : "") : ""; // CanPrint
        const maxPrintsRaw = values.length > 8 ? (values[8] ? values[8].trim() : "") : ""; // MaxAllowedPrints
        // Trim and validate the values
        const filteredEmail = emailValue ? emailValue.trim().toLowerCase() : null;
        const filteredFn = fnValue ? fnValue.trim() : "";
        const filteredLn = lnValue ? lnValue.trim() : "";
        const filteredCountryCode = countryCode ? countryCode.trim() : "";
        const filteredMobileNumber = mobileNumber ? mobileNumber.trim() : "";
        const countryCodeDetailsObj =
          filteredCountryCode != "" ? (resolveCountryCode(filteredCountryCode) || countryCodeDrpOptions.find((cc) => cc.value === filteredCountryCode) || filteredCountryCode) : [];
        const filteredReference = reference ? reference.trim() : "";
        const filteredVerificationType = selectVerificationCode != "" ? VerificationOptionsForFilter.find((opt => opt.value == selectVerificationCode) || selectVerificationCode) : "";
        const filteredVerificationTypeValue = filteredVerificationType ? filteredVerificationType : selectVerificationCode;

        const validCanPrintLookup = ["true", "yes", "1"];
        const validCanPrintAll = ["", "true", "false", "yes", "no", "1", "0"];
        const isValidCanPrint = validCanPrintAll.includes(canPrintRaw.toLowerCase());
        const parsedCanPrint = canPrintRaw !== ""
          ? (validCanPrintLookup.includes(canPrintRaw.toLowerCase()) ? true : (props.defaultCanPrint || false))
          : (props.defaultCanPrint || false);
        const isValidMaxPrints = maxPrintsRaw === "" || /^\d+$/.test(maxPrintsRaw);
        const parsedMaxPrints = maxPrintsRaw !== ""
          ? (isValidMaxPrints ? (parseInt(maxPrintsRaw, 10) || "") : "")
          : (parsedCanPrint ? props.defaultMaxPrintsPerReader : "");
        const isMaxPrintsEdited = maxPrintsRaw !== "";

        const rowArr = [filteredEmail, filteredFn, filteredLn, filteredVerificationTypeValue, countryCodeDetailsObj, filteredMobileNumber, filteredReference, parsedCanPrint, parsedMaxPrints, isMaxPrintsEdited];
        if (!isValidCanPrint && canPrintRaw !== "") {
          rowArr.invalidCanPrint = canPrintRaw;
        }
        if (!isValidMaxPrints) {
          rowArr.invalidMaxPrints = maxPrintsRaw;
        }
        return rowArr;
      })
      .filter((email) => email[0] !== null);
    return emails;
  };

  function findDuplicates(arr) {
    const duplicates = {};
    const result = [];
    for (const email of arr) {
      // Exclude empty emails from duplicates check
      if (email[0].trim() !== "") {
        if (!duplicates[email[0]]) {
          duplicates[email[0]] = true;
        } else {
          result.push(email);
        }
      }
    }
    return result
  }

  function ChangeMaxPrintsPerReaderTexts(textValue) {
    textValue = textValue.replace(/[^0-9]+/g, "");
    if (textValue == "") {
      setMaxPrintsPerReaderText(textValue);
    } else if (textValue.length <= 4 && parseInt(textValue) >= 1 && parseInt(textValue) <= 9999) {
      setMaxPrintsPerReaderText(parseInt(textValue));
    }
    dispatch(updateFormData({ type: "MaxPrintsPerReader", value: textValue }));
  }
  const readers = deepCopyArray(data.authorizedReaders || []);

  props.recipientPrintData.forEach(printReader => {
    const index = readers.findIndex(
      reader => reader[0]?.toLowerCase() === printReader[0]?.toLowerCase()
    );

    if (index !== -1) {
      readers[index][7] = printReader[7];
      readers[index][8] = printReader[8];
    }
  });
  return (
    <>
      {/* alerts */}
      <Alert
        alertType={alertType}
        alertMsg={alertMsg}
        setAlertMsg={setAlertMsg}
        setAlertType={setAlertType}
        className="alerthist-ip"
      ></Alert>
      {/* end */}
      <div className="w-100 red-shadow border-r4 react-multi-email  empty react-multi-email-pd"
        onClick={handleClick} tabIndex={0}>
        {readers.length > 0 &&
          readers.map((emails, index) => (
            <div
              key={"reader-tag-" + index}
              className="d-flex align-items-center longtext"
              data-tag="true"
              id={"labelIp" + index}
            >
              <label
                className="longtextLabel"
                style={{ marginBottom: 0.1 }}
                onDoubleClick={() => {
                  const targetEmailOrName = (emails[0] || "").trim().toLowerCase();
                  const grp = emails[11] || (props.contactGroups || []).find((g) => {
                    if (!g) return false;
                    const gName = (g.name || g.Name || g.groupName || g.GroupName || "").trim().toLowerCase();
                    const gAlias = (g.aliasEmail || g.AliasEmail || g.email || g.Email || g.dlEmail || "").trim().toLowerCase();
                    return (gAlias && gAlias === targetEmailOrName) || (gName && gName === targetEmailOrName);
                  });
                  if (emails[10] === true || emails[2] === "(Distribution List)" || emails[2] === "(DL)" || emails.isGroup || grp) {
                    setSelectedDLGroup(grp || { aliasEmail: emails[0], name: emails[1] });
                    setIsDLModalOpen(true);
                  } else {
                    handleReceiptsFnLnAdd(emails[0], emails[1], emails[2], emails[3], emails[4], emails[5], emails[6], emails[7], emails[8], index, emails[9]);
                  }
                }}
              >
                <div className="1">
                  {" "}
                  {emails && emails.length > 0 ? (
                    (() => {
                      const targetEmailOrName = (emails[0] || "").trim().toLowerCase();
                      const matchedG = emails[11] || (props.contactGroups || []).find((g) => {
                        if (!g) return false;
                        const gName = (g.name || g.Name || g.groupName || g.GroupName || "").trim().toLowerCase();
                        const gAlias = (g.aliasEmail || g.AliasEmail || g.email || g.Email || g.dlEmail || "").trim().toLowerCase();
                        const gAliasPrefix = gAlias ? gAlias.split("@")[0].toLowerCase() : "";
                        return (gAlias && gAlias === targetEmailOrName) || (gName && gName === targetEmailOrName) || (gAliasPrefix && gAliasPrefix === targetEmailOrName);
                      });
                      const isDLGroup = Boolean(emails[10] === true || emails.isGroup || emails.isDLGroup || emails[2] === "(Distribution List)" || emails[2] === "(DL)" || matchedG);
                      if (isDLGroup) {
                        let grpName = emails[1] && emails[1] !== "(Distribution List)" && emails[1] !== "(DL)" ? emails[1] : "";
                        if (!grpName) {
                          grpName = matchedG?.name || matchedG?.Name || matchedG?.groupName || matchedG?.GroupName || emails[0]?.split("@")[0] || "Distribution List";
                        }
                        const grpEmail = matchedG?.aliasEmail || matchedG?.AliasEmail || matchedG?.email || matchedG?.Email || matchedG?.dlEmail || emails[0] || "";
                        return `${grpName} <${grpEmail}> (DL) `;
                      } else {
                        const fn = String(typeof emails === "object" && !Array.isArray(emails) ? (emails.firstName || emails.FirstName || "") : (emails[1] || "")).trim();
                        const ln = String(typeof emails === "object" && !Array.isArray(emails) ? (emails.lastName || emails.LastName || "") : (emails[2] || "")).trim();
                        const emailAddr = String(typeof emails === "object" && !Array.isArray(emails) ? (emails.email || emails.Email || "") : (emails[0] || "")).trim();
                        const fullName = `${fn} ${ln}`.trim();
                        if (fullName && fullName !== "(DL)" && fullName !== "(Distribution List)") {
                          return `${fullName} <${emailAddr}>`;
                        }
                        return emailAddr;
                      }
                    })()
                  ) : (
                    emails
                  )}
                </div>
              </label>
              <span
                data-tag-handle="true"
                className="material-icons text-danger top-2 ms-2"
                onClick={() => removeEmail(consMultipleEmails, emails, index)}
              >
                clear
              </span>
            </div>
          ))}

        <input
          ref={ref}
          id={props.id}
          type={props.type}
          tabIndex={props.tabindex}
          onKeyDown={(e) => handleKeyDown(e)}
          onKeyUp={(e) => handleKeyUp(e)}
          onChange={(e) => setConsMultipleEmail(e.target.value)}
          onBlur={(e) => handleKeyDown(e)}
          className="w-100 red-shadow border-r4 sendCreate-field"
          constmultipleemails={consMultipleEmails}

          value={consMultipleEmail}
          placeholder={data.authorizedReaders.length > 0 ? "" : props.tabValue === "send" ? selectedLanguage.LstLanguageCodes.UI_To : selectedLanguage.LstLanguageCodes.UI_AuthorizedReadersEmails}
        ></input>
        <img
          src={EditIcon}
          className="bulkEditFnLnBtn"
          alt="logo"
          onClick={() => handleReceiptsFnLnEdit()}
          style={{ cursor: "pointer", width: "27px", marginRight: '10px' }}
          title={selectedLanguage.LstLanguageCodes.UI_AddDetails}
        />
        <img
          src="assets/img/uploadFile.png"
          className="bulKUplodbtn mleft275"
          alt="logo"
          onClick={() => handleReceiptsAdd()}
          style={{ cursor: "pointer", width: "33px" }}
          title={selectedLanguage.LstLanguageCodes.UI_ImportReaderstooltip}
        />
        <span className="bulKUplodbtn "></span>
      </div>

      {isModalOpen && (
        <div
          className="modalCus"
          id="myModal"
          onRequestClose={handleCloseModal}
          shouldCloseOnOverlayClick={true}
        >
          <div
            className="modal-dialog modal-dialog-centered custom-width-model mobile-modal"
            style={{ maxWidth: "955px", height: "40px" }}
          >
            <div className="modal-content" >
              <div className="modal-header d-flex align-items-center justify-content-right">
                <h4 className="mb-0 text-danger fw-bold font-20" htmlFor="">
                  {selectedLanguage.LstLanguageCodes.UI_ImportReaders}
                </h4>

                <button
                  type="button"
                  className="btn btn-outline-danger Readerclose modalclose download"
                  onClick={() => handleCloseModal()}
                >
                  <span className="material-icons font-20">highlight_off</span>
                </button>
              </div>
              <div className="Mtop9 ">
                <span className="itemsalign">
                  {selectedLanguage.LstLanguageCodes.UI_PleaseDownloadTheXLSorCSV}{" "}

                </span>
                <span>
                  <img
                    src={"assets/img/icons/CSVdownload.png"}
                    className="h-44p mleft15"
                    alt="Download"
                    id="DownloadReadersCSV"
                    onClick={(e) => DownloadReaderCSV()}
                  />
                </span>
                <span>
                  <img
                    src={"assets/img/icons/XLSdownload.png"}
                    className="h-44p "
                    alt="Download"
                    id="DownloadReadersXLS"
                    onClick={(e) => DownloadReaderXLS()}
                  />
                </span>
              </div>
              <div className="col-sm-12 col-md-12 col-lg-5 dragdropwidth ps-2 pe-0 res-pe0">
                <div
                  className={
                    AddDragActive == true
                      ? "active-drop drag dragdropheight upload form-control ms-2 "
                      : "drag dragdropheight upload form-control ms-2 "
                  }
                  style={{ display: "grid" }}
                >
                  <p className="d-flex flex-column justify-content-center font-w600 font-14 mb-0">
                    <div className="row row-height">
                      <div
                        className={
                          ReadersinputFields.length > 0
                            ? "d-flex flex-column align-items-center justify-content-center col-md-5 ps-1 pe-2"
                            : "d-flex flex-column align-items-center justify-content-center col-md-12 ps-1 pe-2 pt-12Moz"
                        }
                      >
                        <input
                          type="file"
                          id="imgFileReaders"
                          title={ReadersfileName}
                          onClick={(e) => ReadersfileSelectionClick(e)}
                          onChange={(e) => ReadersfileSelection(e)}
                        ></input>
                        <span className="pb-1 pt-1 light">
                          {
                            selectedLanguage.LstLanguageCodes
                              .UI_DragandDropfilesHere
                          }
                        </span>
                        <span className="pb-1">
                          {selectedLanguage.LstLanguageCodes.UI_or}
                        </span>
                        <span className="light underline">
                          {" "}
                          {
                            selectedLanguage.LstLanguageCodes
                              .UI_ClickAndSelectFiles
                          }
                        </span>
                      </div>
                      <div
                        className={
                          ReadersinputFields.length > 0
                            ? "col-md-7 col-sm-12 ps-1 pe-2"
                            : "col-md-7 col-sm-12 ps-1 pe-2 d-none"
                        }
                        style={{
                          borderLeft: "2px dashed rgb(67 94 190 / 50%)",
                        }}
                      >
                        <div className="file-scrollbar d-none d-md-block">
                          {ReadersinputFields.map((data, index) => {
                            return (
                              <aside
                                className="d-flex align-items-center row mt-1 pb-1 w-100"
                                style={{ marginLeft: "0px" }}
                                draggable
                                // onDragStart={(e) => dragStart(e, index)}
                                // onDragOver={(e) => dragOver(e, index)}
                                // onDrop={(e) => dragDrop(e, index)}
                                key={index}
                              >
                                <div
                                  className={
                                    data.edit == true
                                      ? "d-flex align-items-center box-width col-sm-10 ps-0"
                                      : "d-flex align-items-center  box-width col-sm-8 ps-0"
                                  }
                                >
                                  {/* <span className="material-icons font-20">
                                  task
                                </span> */}
                                  {data.edit == false && (
                                    <span
                                      className="ms-1 font-14 font-w400 filename-text"
                                      title={data.orgFileName}
                                    >
                                      {data.mdfFileName + data.fileFormat}
                                    </span>
                                  )}
                                  {data.edit == true && (
                                    <>
                                      <input
                                        className="border-r4 edit-box"
                                        type="text"
                                        placeholder={
                                          selectedLanguage.LstLanguageCodes
                                            .UI_EnterFilename
                                        }
                                        value={data.mdfFileName}
                                        onDragStart={(e) => {
                                          e.preventDefault();
                                        }}
                                        onChange={(event) =>
                                          fileNameChange(
                                            data.indexVal,
                                            event.target.value
                                          )
                                        }
                                      ></input>
                                      {/* {data.fileFormat} */}
                                    </>
                                  )}
                                </div>
                              </aside>
                            );
                          })}
                        </div>
                      </div>
                    </div>
                  </p>
                </div>

                <div className="row mt-3 d-flex align-items-center w-100"></div>
              </div>
              {selectedFiles.length > 0 && (
                <span className="ReadersFileName ms-4 ps-2" title={fileNames}>
                  {selectedLanguage.LstLanguageCodes.UI_FileName}: {fileNames}
                </span>
              )}
              <div className="mb-3 mt-2 pb-2">
                {/* <input type="button" className="UploadReaders btn btn-primary" onClick={handleUpload} value="Upload"></input> */}
                <button
                  type="button"
                  onClick={() => {
                    handleFileChange();
                  }}
                  disabled={!selectedFiles || selectedFiles.length === 0}
                  className="btn btn-primary UploadReaders"
                >
                  {selectedLanguage.LstLanguageCodes.UI_Upload}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
      {isModalFnLnOpen && (
        <div
          className="modalCus"
          id="myModal"
          onRequestClose={handleCloseFnLnModal}
          shouldCloseOnOverlayClick={true}
        >
          <div
            className="modal-dialog modal-dialog-centered custom-width-model mobile-modal"
            style={{ maxWidth: "450px", height: "250px", margin: "1.75rem auto" }}
          >
            <div className="modal-content" style={{ minHeight: "250px" }}>
              <div className="modal-header d-flex justify-content-right" style={{ padding: '0.6rem 1rem' }}>
                <h4
                  className="mb-0 text-danger fw-bold font-18 clsFnLnHeading"
                  htmlFor=""
                >
                  {selectedLanguage.LstLanguageCodes.UI_AddEditUsers}
                </h4>

                <button
                  type="button"
                  className="btn btn-outline-danger Readerclose modalclose download mt-2"
                  onClick={() => handleCloseFnLnModal()}
                >
                  <span className="material-icons font-20">highlight_off</span>
                </button>
              </div>
              <div className="col-sm-12 col-md-12 col-lg-12 px-3 mt-3 font-18 readerEdit-mail">
                <input
                  className="clsFnLn form-control"
                  name="email"
                  title="Email"
                  placeholder="Email"
                  value={currentEmail}
                  onChange={(e) => setCurrentEmail(e.target.value)}
                  onBlur={(e) => {
                    const trimmed = e.target.value.trim();
                    setCurrentEmail(trimmed);
                    if (trimmed) {
                      const lowerE = trimmed.toLowerCase();
                      const matchedContact = (props.contacts || []).find((c) => {
                        if (!c) return false;
                        const cEmail = (c.email || c.Email || "").trim().toLowerCase();
                        return cEmail && cEmail === lowerE;
                      });
                      if (matchedContact) {
                        if (!firstName) setFirstName(matchedContact.firstName || matchedContact.FirstName || "");
                        if (!lastName) setLastName(matchedContact.lastName || matchedContact.LastName || "");
                        if (!mobileNumber) setMobileNumber(matchedContact.mobile || matchedContact.Mobile || "");
                        if (!reference) setReference(matchedContact.referenceTag || matchedContact.ReferenceTag || "");
                        if (!selectedCode || selectedCode === "" || selectedCode?.value === "+Code") {
                          const rawCC = matchedContact.phoneCode || matchedContact.PhoneCode || "";
                          setSelectedCode(resolveCountryCode(rawCC) || (rawCC ? { value: rawCC, label: rawCC } : ""));
                        }
                      }
                    }
                  }}
                ></input>
              </div>
              <div className="col-sm-12 col-md-12 col-lg-12 px-3  mt-3 readerEdit-mail">
                <input
                  className="clsFnLn form-control"
                  name="FirstName"
                  title={
                    selectedLanguage
                      .LstLanguageCodes.UI_FirstName
                  }
                  placeholder={
                    selectedLanguage
                      .LstLanguageCodes.UI_FirstName
                  }
                  value={firstName}
                  onChange={(e) => setFirstName(e.target.value)}
                ></input>
              </div>
              <div className="col-sm-12 col-md-12 col-lg-12 px-3 mt-3 readerEdit-mail">
                <input
                  className="clsFnLn form-control"
                  name="LastName"
                  title={
                    selectedLanguage
                      .LstLanguageCodes.UI_LastName
                  }
                  placeholder={
                    selectedLanguage
                      .LstLanguageCodes.UI_LastName
                  }
                  value={lastName}
                  onChange={(e) => setLastName(e.target.value)}
                ></input>

              </div>
              <div className="col-sm-12 col-md-12 col-lg-12 px-3 mt-3 res-pe0 d-flex readerEdit-mail">
                {/* Country Code Dropdown */}
                {/* <div className="custom-inputBorder1">
                  <Select
                    value={selectedCode?.value ? selectedCode : globePlaceholder}
                    onChange={(event) =>
                      handleCodeChange(event)
                    }
                    options={countryCodeOptions}
                    placeholder={selectedLanguage.LstLanguageCodes.UI_CountryCode}
                    styles={{
                      control: (provided) => ({
                        ...provided,
                        fontSize: '15px',
                        height: '43px',
                        width: '163px',
                        border: '1px solid #ccc',
                        borderRadius: '4px 0 0 4px',
                        boxShadow: '1px 5px 5px -4px rgb(195 198 203)'
                      }),
                      menu: (provided) => ({
                        ...provided,
                        // zIndex: 9999,
                        width: '280px',
                        marginTop: '20px',
                        maxHeight: '250px',
                        overflowY: 'auto',
                      }),
                      menuPortal: (provided) => ({
                        ...provided,
                        zIndex: 9999,
                      }),
                      indicatorSeparator: () => ({
                        display: 'none',
                      }),
                    }}
                    menuPortalTarget={document.body}
                    // menuPosition="absolute"
                    menuPosition="fixed"
                    menuShouldScrollIntoView={false}
                    getOptionLabel={(e) => `${e.label}`}
                    getOptionValue={(e) => `${e.value}`}
                    formatOptionLabel={(data, { context }) => (
                      <div style={{ display: 'flex', alignItems: 'center' }}>
                        <div
                          className={`${data.label === "+Code"
                            ? "bg-  "
                            : `bg-${data.languageCode}`
                            }`}
                          style={{
                            width: '36px',
                            height: '16px',
                            marginRight: '8px',
                          }}
                        ></div>
                        {context === 'menu' ? `${data.label}` : `${data.value ? data.value.split('-')[0] : ''}`}
                      </div>
                    )}
                    noOptionsMessage={() => null}
                  />
                </div> */}

                {/* <input
                  type="text"
                  className="form-control res-mobileinput"
                  value={mobileNumber}
                  maxLength={(selectedCode == undefined || selectedCode == null || selectedCode == "" || selectedCode == [] || selectedCode.value == "Country Code") ? 10 : selectedCode.mobileMaxLeng}
                  onChange={(evnt) => handleMobileChange(evnt)}
                  placeholder={selectedLanguage.LstLanguageCodes.UI_Mobile}
                  style={{
                    height: '43px',
                    width: '65%',
                    border: '1px solid #ccc',
                    borderLeft: 'none',
                    borderRadius: '0 4px 4px 0',
                    padding: '14px',
                    position: 'absolute',
                    left: '140px'
                  }}
                /> */}
              </div>
              <div className=" col-sm-12 col-md-12 col-lg-12 px-3  readerEdit-mail">
                <Select
                  options={VerificationOptions}
                  value={selectVerificationCode?.value ? selectVerificationCode : ""}
                  onChange={(event) => handleVerificationChange(event)}
                  disabled={props.securityLevel == 1 ? true : false}
                  placeholder={selectedLanguage.LstLanguageCodes.UI_SendVerificationCodeTo}
                  className={`sendVerficationCodeBorder ${props.securityLevel == 1 ? "disable_section user_register" : ""}`}
                  //  closeMenuOnScroll={() => true}
                  styles={{

                    control: (provided) => ({
                      ...provided,
                      display: "flex",
                      fontSize: "15px",
                      width: "100%",
                      minHeight: "40px",
                      height: '40px',
                    }),
                    valueContainer: (provided) => ({
                      ...provided,
                      height: "40px",
                    }),
                    indicatorsContainer: (provided) => ({
                      ...provided,
                      height: "40px",
                    }),
                    placeholder: (provided) => ({
                      ...provided,
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      textAlign: "center",
                      width: "100%",
                      cursor: "default",
                    }),
                    menu: (provided) => ({
                      ...provided,
                      zIndex: 9999,
                      // width: "233px",
                      overflow: "hidden",
                      //marginTop: '18px',
                      maxHeight: "300px",
                      overflowY: "auto",
                      marginTop: "3px",
                    }),
                    menuPortal: (provided) => ({
                      ...provided,
                      zIndex: 9999,
                      // width: "233px",
                      //marginTop: '4px',
                    }),


                  }}
                />
              </div>
              <div className="col-sm-12 col-md-12 col-lg-12 px-3 mt-3">
                <div class="input-group custom-inputBorder" >
                  <span
                    className="input-group-text mobile-group50"
                    style={{ padding: "0px", width: '30%' }}>
                    <Select
                      value={(resolveCountryCode(selectedCode) || (selectedCode?.value ? selectedCode : null)) || globePlaceholder}
                      onChange={(event) =>
                        handleCodeChange(event)
                      }
                      options={countryCodeOptions}
                      placeholder={selectedLanguage.LstLanguageCodes.UI_CountryCode}
                      menuPosition="fixed"
                      styles={{
                        control: (provided) => ({
                          ...provided,
                          display: "flex",
                          fontSize: "15px",
                          width: "100%",
                          minHeight: "40px",
                          height: '40px',
                        }),
                        valueContainer: (provided) => ({
                          ...provided,
                          height: "40px",
                        }),
                        indicatorsContainer: (provided) => ({
                          ...provided,
                          height: "40px",
                        }),
                        placeholder: (provided) => ({
                          ...provided,
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          textAlign: "center",
                          width: "100%",
                          cursor: "default",
                        }),
                        menu: (provided) => ({
                          ...provided,
                          zIndex: 9999,
                          width: "233px",
                          overflow: "hidden",
                          // marginTop: '18px',
                          maxHeight: "300px",
                          overflowY: "auto",
                        }),
                        menuPortal: (provided) => ({
                          ...provided,
                          zIndex: 9999,
                          width: "233px",
                          //marginTop: '4px',
                        }),
                        indicatorSeparator: () => ({
                          display: "none",
                        }),
                      }}
                      menuPortalTarget={document.body}
                      menuShouldScrollIntoView={false}
                      getOptionLabel={(e) => `${e.label}`}
                      getOptionValue={(e) => `${e.value}`}
                      formatOptionLabel={(
                        data,
                        { context }
                      ) => (
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                          }}>
                          <div
                            className={`${data.label === "+Code"
                              ? "bg-"
                              : `bg-${data.languageCode}`
                              }`}
                            style={{
                              width: "36px",
                              height: "16px",
                              marginRight: "8px",
                            }}></div>
                          {context === "menu"
                            ? `${data.label}`
                            : `${data.value.split("-")[0]}`}
                        </div>
                      )}
                      noOptionsMessage={() => null}
                    />
                  </span>
                  <input
                    type="text"
                    className="form-control res-mobileinput"
                    value={mobileNumber}
                    maxLength={(selectedCode == undefined || selectedCode == null || selectedCode == "" || selectedCode == [] || selectedCode.value == "+Code") ? 10 : selectedCode.mobileMaxLeng}
                    onChange={(evnt) => handleMobileChange(evnt)}
                    placeholder={selectedLanguage.LstLanguageCodes.UI_Mobile}
                  />
                </div>
              </div>

              <div className="col-sm-12 col-md-12 col-lg-12 px-3 mt-3 readerEdit-mail">
                <input
                  className="clsFnLn form-control"
                  name="reference"
                  title={
                    selectedLanguage
                      .LstLanguageCodes.UI_ReferenceTxt
                  }
                  placeholder={
                    selectedLanguage
                      .LstLanguageCodes.UI_ReferenceTxt
                  }
                  value={reference}
                  onChange={(e) => setReference(e.target.value)}
                ></input>

              </div>
              <div className="d-flex align-items-center" style={{ borderRadius: "0.25rem", margin: "10px 0px 0px 0px" }}>
                <div className="checkbox mt-0 mb-0 d-flex align-items-center" style={{ border: "1px solid #ced4da", padding: "11px", whiteSpace: "nowrap", position: "relative", left: "1rem" }}>
                  <label className="ps-0 mb-0">
                    <input type="checkbox" onChange={(e) => {
                      setPrint(e.target.checked)
                      if (e.target.checked === false) {
                        dispatch(updateFormData({ type: "MaxPrintsPerReader", value: "" }));
                      }
                      dispatch(updateFormData({ type: "CanPrint", value: e.target.checked }));
                    }}
                      value={canPrint} id="txtPrint" checked={((canPrint) && props.printEnabledType === "everyone") ? true : canPrint}
                      disabled={(!props.defaultCanPrint || props.printEnabledType === "everyone")}
                    />
                    <span className="cr" tabIndex="42" style={{ right: "5px" }}>
                      <i className="cr-icon material-icons">check</i>
                    </span>
                    <span className={`toolltipModified  top`} onMouseEnter={handleMouseEnter} style={{ right: "7px" }}>
                      {selectedLanguage.LstLanguageCodes.UI_CanPrint}
                    </span>
                  </label>
                </div>
                <div className="d-flex flex-grow-1 align-items-center">
                  <div className="input-group field mt-0 res-nowwrap control-height custom-inputBorder me-3" style={{ flex: 1, minWidth: "150px" }}>
                    <span className="input-group-text toolltipModified res-width forced-label-style truncate ellipsis-text ellipsis-text-max-keys" style={{ minWidth: "175px" }} title={selectedLanguage.LstLanguageCodes.UI_MaxPrintsPerReader}>
                      {selectedLanguage.LstLanguageCodes.UI_MaxAllowedPrints}
                    </span>
                    <input type="text" placeholder={selectedLanguage.LstLanguageCodes.UI_Unlimited}
                      title={maxPrintsPerReaderText === "" ? selectedLanguage.LstLanguageCodes.UI_Unlimited : ""}
                      className="control form-control h-47p border-Left"
                      value={(props.securityLevel === 1 || !canPrint) ? "" : (maxPrintsPerReaderText !== undefined && maxPrintsPerReaderText !== null) ? maxPrintsPerReaderText : (props.defaultMaxPrintsPerReader || "")}
                      onChange={(e) => ChangeMaxPrintsPerReaderTexts(e.target.value)}
                      disabled={props.securityLevel === 1 || !canPrint}
                    />
                  </div>
                </div>
              </div>
              <div className="col-sm-12 col-md-12 col-lg-12 mt-4 mb-3 py-1 pe-3">
                <button
                  type="button"
                  onClick={() => {
                    handleAddFnLn();
                  }}
                  className="btn btn-primary px-5"
                  style={{ float: "inline-end" }}
                >
                  {selectedLanguage.LstLanguageCodes.UI_Save}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
      {isModalFnLnEditOpen && (
        <div className="modalCus" id="myModal">
          <div
            className="modal-dialog modal-dialog-centered mobile-modal"
            style={{ maxWidth: '1150px', width: "auto" }}
          >
            <div className="modal-content">
              <div className="modal-header d-flex justify-content-start">
                <h4 className="mb-0 text-danger fw-bold font-20" htmlFor="">
                  {selectedLanguage.LstLanguageCodes.UI_AddEditUsers}
                </h4>
              </div>

              <div className="modal-body pb-0 ps-3 pe-3 res-px0">
                <div
                  className=" authorizedReaders table-scrollbar max-width-popup "
                  style={{
                    maxHeight: "350px",
                    overflow: "auto",
                    overflowX: "hidden",
                    display: "block",
                    paddingRight: "3px",
                  }}
                >
                  {consEditMultipleEmails.map((data, index) => {
                    const isDLRow = Boolean(
                      data[10] === true ||
                      data.isGroup ||
                      data.isDLGroup ||
                      data[2] === "(DL)" ||
                      data[2] === "(Distribution List)"
                    );

                    return (
                      <div className="row d-flex align-items-center ps-1 mb-2 common-border" style={{ marginTop: '2%' }}>
                        {consEditMultipleEmails.length !== 1 ? (
                          <div className="col-11 col-sm-11 col-md-11 pe-0">
                            <div className="w-100" key={index}>
                              <div className="gap-12p d-flex align-items-center mobile-flow w-max-content" >
                                <div className="gridcolSend-22">
                                  <input
                                    id={"email" + index}
                                    type="text"
                                    autoComplete="none"
                                    onChange={(evnt) => !isDLRow && handleChange(index, evnt)}
                                    onBlur={(evnt) => !isDLRow && handleChange(index, evnt)}
                                    value={data[0]}
                                    disabled={isDLRow}
                                    name={"email-" + index}
                                    className={`form-control custom-inputBorder ${isDLRow ? "bg-light text-muted cursor-not-allowed" : ""}`}
                                    placeholder={
                                      selectedLanguage.LstLanguageCodes.UI_Email
                                    }
                                    title={data[0]}
                                  />
                                </div>
                                <div className="gridcol-17 pe-0 gridcolSend-16">
                                  <input
                                    id={"firstName" + index}
                                    type="text"
                                    autoComplete="none"
                                    onChange={(evnt) => !isDLRow && handleChange(index, evnt)}
                                    value={data[1]}
                                    disabled={isDLRow}
                                    name={"firstName-" + index}
                                    className={`form-control custom-inputBorder ${isDLRow ? "bg-light text-muted cursor-not-allowed" : ""}`}
                                    placeholder={
                                      selectedLanguage
                                        .LstLanguageCodes.UI_FirstName
                                    }
                                    title={data[1]}
                                  />
                                </div>
                                <div className="gridcol-17 pe-0 gridcolSend-16">
                                  <input
                                    id={"lastName" + index}
                                    type="text"
                                    autoComplete="none"
                                    onChange={(evnt) => !isDLRow && handleChange(index, evnt)}
                                    value={data[2]}
                                    disabled={isDLRow}
                                    name={"lastName-" + index}
                                    className={`form-control custom-inputBorder ${isDLRow ? "bg-light text-muted cursor-not-allowed" : ""}`}
                                    placeholder={
                                      selectedLanguage
                                        .LstLanguageCodes.UI_LastName
                                    }
                                    title={data[2]}
                                  />
                                </div>
                              </div>
                              <div style={{ marginTop: "9px" }} className="gap-12p d-flex align-items-center mobile-flow w-max-content">
                                <div className="gridcol-17 pe-0 gridcolSend-16" >
                                  <Select
                                    options={VerificationOptions}
                                    value={data[3]?.value ? data[3] : ""}
                                    isDisabled={isDLRow || props.securityLevel == 1}
                                    disabled={isDLRow || props.securityLevel == 1 ? true : false}

                                    placeholder={selectedLanguage.LstLanguageCodes.UI_SendVerificationCodeTo}
                                    className={`sendVerficationCodeBorder ${(props.securityLevel == 1 || isDLRow) ? "disable_section user_register" : ""}`}
                                    menuPortalTarget={document.body}
                                    menuPosition="fixed"
                                    closeMenuOnScroll={() => true}
                                    onChange={(event => !isDLRow && handleVerificationChange(event, index))}
                                    styles={{
                                      control: (provided) => ({
                                        ...provided,
                                        display: "flex",
                                        fontSize: "15px",
                                        width: "100%",
                                        minHeight: "40px",
                                        height: '40px',
                                      }),
                                      valueContainer: (provided) => ({
                                        ...provided,
                                        height: "40px",
                                      }),
                                      indicatorsContainer: (provided) => ({
                                        ...provided,
                                        height: "40px",
                                      }),
                                      placeholder: (provided) => ({
                                        ...provided,
                                        whiteSpace: "nowrap",
                                        overflow: "hidden",
                                        textOverflow: "ellipsis",
                                        textAlign: "center",
                                        width: "100%",
                                        cursor: "default",
                                      }),
                                      menu: (provided) => ({
                                        ...provided,
                                        zIndex: 999999,
                                        // width: "233px",
                                        overflow: "hidden",
                                        // marginTop: '18px',
                                        maxHeight: "300px",
                                        overflowY: "auto",
                                        marginTop: "3px",
                                      }),
                                      menuPortal: (provided) => ({
                                        ...provided,
                                        zIndex: 9999,
                                        // width: "233px",
                                        //marginTop: '4px',
                                      }),
                                    }}

                                  />
                                </div>
                                <div className="gridcol-25 add-grid">
                                  <div className="input-group custom-inputBorder" style={{ width: '125.5%' }}>
                                    <span
                                      className="input-group-text mobile-group50"
                                      style={{ padding: "0px", width: '37%' }}>
                                      <Select
                                        value={(resolveCountryCode(data[4]) || (data[4]?.value ? data[4] : null)) || globePlaceholder}
                                        // placeholder={selectedLanguage.LstLanguageCodes.UI_CountryCode}
                                        isDisabled={isDLRow}
                                        onChange={(event) => !isDLRow && handleCodeChange(event, index)}
                                        options={countryCodeOptions}
                                        // closeMenuOnScroll={() => true}
                                        menuPosition="fixed"
                                        styles={{
                                          control: (provided) => ({
                                            ...provided,
                                            display: 'flex',
                                            fontSize: '15px',
                                            width: '100%',
                                            minHeight: "40px",
                                            height: '40px',
                                            // alignItems: 'center',
                                            // justifyContent: 'center',
                                            // height: '45px',
                                            //width: '156px',
                                            // border: '1px solid #ccc',
                                            // borderRadius: '4px 0 0 4px',
                                            // marginLeft: '-37px',
                                            // overflow: 'hidden',
                                            // boxShadow: '1px 5px 5px -4px rgb(195 198 203)',
                                          }),
                                          valueContainer: (provided) => ({
                                            ...provided,
                                            height: "40px",
                                          }),
                                          indicatorsContainer: (provided) => ({
                                            ...provided,
                                            height: "40px",
                                          }),
                                          placeholder: (provided) => ({
                                            ...provided,
                                            whiteSpace: 'nowrap',
                                            overflow: 'hidden',
                                            textOverflow: 'ellipsis',
                                            textAlign: 'center',
                                            width: '100%',
                                            cursor: 'default',
                                          }),
                                          menu: (provided) => ({
                                            ...provided,
                                            zIndex: 9999,
                                            width: '233px',
                                            overflow: 'hidden',
                                            // marginTop: '18px',
                                            maxHeight: '300px',
                                            overflowY: 'auto',
                                          }),
                                          menuPortal: (provided) => ({
                                            ...provided,
                                            zIndex: 9999,
                                            width: '233px',
                                            //marginTop: '4px',
                                          }),
                                          indicatorSeparator: () => ({
                                            display: 'none',
                                          }),
                                        }}
                                        menuPortalTarget={document.body}
                                        getOptionLabel={(e) => `${e.label}`}
                                        getOptionValue={(e) => `${e.value}`}
                                        title="Select code"
                                        formatOptionLabel={(data, { context }) => (
                                          <div style={{ display: 'flex', alignItems: 'center' }}>
                                            <div
                                              className={`${data.label === "+Code"
                                                ? "bg-  "
                                                : `bg-${data.languageCode}`
                                                }`}
                                              style={{
                                                width: '36px',
                                                height: '16px',
                                                marginRight: '8px',
                                              }}
                                            ></div>
                                            {context === 'menu' ? `${data.label}` : `${data.value ? data.value.split('-')[0] : ''}`}
                                          </div>
                                        )}
                                        noOptionsMessage={() => null}
                                      />
                                    </span>
                                    <input type="text"
                                      className={`form-control res-mobileinput border-Left ${isDLRow ? "bg-light text-muted cursor-not-allowed" : ""}`}
                                      value={data[5]}
                                      disabled={isDLRow}
                                      maxLength={(data[4] == undefined || data[4] == null || data[4] == "" || data[4] == [] || data[4].value == "+Code") ? 10 : data[4].mobileMaxLeng}
                                      onChange={(evnt) => !isDLRow && handleMobileChange(evnt, index)}
                                      placeholder={selectedLanguage.LstLanguageCodes.UI_Mobile} title={data[5]} />
                                  </div>

                                </div>
                                <div className="gridcol-17 pe-0 gridcolSend-16" style={{ marginLeft: '6%' }}>
                                  <input
                                    id={"reference" + index}
                                    type="text"
                                    autoComplete="none"
                                    onChange={(evnt) => !isDLRow && handleChange(index, evnt)}
                                    value={data[6]}
                                    disabled={isDLRow}
                                    name={"reference-" + index}
                                    className={`form-control custom-inputBorder ${isDLRow ? "bg-light text-muted cursor-not-allowed" : ""}`}
                                    placeholder={
                                      selectedLanguage
                                        .LstLanguageCodes.UI_ReferenceTxt
                                    }
                                    title={data[6]}
                                  />
                                </div>
                              </div>
                              <div className="gap-12p d-flex align-items-center mobile-flow w-max-content">
                                <div className="d-flex align-items-center" style={{ borderRadius: "0.25rem", margin: "10px 0px 0px 0px" }}>
                                  <div className="checkbox mt-0 mb-0 d-flex align-items-center" style={{ border: "1px solid #ced4da", padding: "11px", whiteSpace: "nowrap" }}>
                                    <label className="ps-0 mb-0">
                                      <input
                                        type="checkbox"
                                        onChange={(e) => !isDLRow && handleChange(index, {
                                          target: { name: `canPrint-${index}`, checked: e.target.checked }
                                        })}
                                        value={canPrint}
                                        id="txtPrint"
                                        checked={props.defaultCanPrint && props.printEnabledType === "everyone" ? true : (data[7] || false)} disabled={isDLRow || (!props.defaultCanPrint || props.printEnabledType === "everyone")}
                                      />
                                      <span className="cr" tabIndex="42">
                                        <i className="cr-icon material-icons">check</i>
                                      </span>
                                      <span
                                        className={`toolltipModified  top`}
                                        onMouseEnter={handleMouseEnter}>
                                        {selectedLanguage.LstLanguageCodes.UI_CanPrint}
                                      </span>
                                    </label>
                                  </div>
                                  <div className="d-flex flex-grow-1 align-items-center">
                                    <div className="input-group field mt-0 res-nowwrap control-height custom-inputBorder me-3" style={{ flex: 1, minWidth: "150px" }}>
                                      <span className="input-group-text toolltipModified res-width forced-label-style truncate ellipsis-text ellipsis-text-max-keys" style={{ minWidth: "175px" }} title={selectedLanguage.LstLanguageCodes.UI_MaxPrintsPerReader}>
                                        {selectedLanguage.LstLanguageCodes.UI_MaxAllowedPrints}
                                      </span>
                                      <input
                                        type="text"
                                        placeholder={selectedLanguage.LstLanguageCodes.UI_Unlimited}
                                        title={maxPrintsPerReaderText === "" ? selectedLanguage.LstLanguageCodes.UI_Unlimited : ""}
                                        className={`control form-control h-47p border-Left ${isDLRow ? "bg-light text-muted cursor-not-allowed" : ""}`}
                                        value={props.securityLevel === 1 ? "" : ((props.defaultCanPrint && props.printEnabledType === "everyone")
                                          ? (data[9] === true
                                            ? (data[8] !== undefined && data[8] !== null ? data[8] : "")
                                            : (data[8] !== undefined && data[8] !== null ? data[8] : ""))
                                          : (!data[7] ? "" : (data[8] !== undefined && data[8] !== null ? data[8] : "")))
                                        }
                                        onChange={(e) => !isDLRow && handleChange(index, {
                                          target: { name: `maxPrintsPerReader-${index}`, value: e.target.value }
                                        })}
                                        disabled={isDLRow || props.securityLevel === 1 || !props.defaultCanPrint || !data[7]}
                                      />
                                    </div>
                                  </div>
                                </div>
                                <div></div>
                                <div></div>
                              </div>
                            </div>
                          </div>
                        ) : (
                          <div className=" col-sm-12 col-md-12">
                            <div className="gap-12p d-flex align-items-center mobile-flow w-max-content" key={index} >
                              <div className="gridcolSend-22">
                                <input className={`form-control custom-inputBorder ${isDLRow ? "bg-light text-muted cursor-not-allowed" : ""}`}
                                  id={"email" + index}
                                  type="text"
                                  autoComplete="none"
                                  onChange={(evnt) => !isDLRow && handleChange(index, evnt)}
                                  onBlur={(evnt) => !isDLRow && handleChange(index, evnt)}
                                  value={data[0]}
                                  disabled={isDLRow}
                                  name={"email-" + index}
                                  placeholder={
                                    selectedLanguage.LstLanguageCodes.UI_Email
                                  }
                                  title={data[0]}
                                />
                              </div>
                              <div className="gridcol-17 pe-0 gridcolSend-16 res-16p">
                                <input className={`form-control custom-inputBorder ${isDLRow ? "bg-light text-muted cursor-not-allowed" : ""}`}
                                  id={"firstName" + index}
                                  type="text"
                                  autoComplete="none"
                                  onChange={(evnt) => !isDLRow && handleChange(index, evnt)}
                                  value={data[1]}
                                  disabled={isDLRow}
                                  name={"firstName-" + index}
                                  placeholder={
                                    selectedLanguage
                                      .LstLanguageCodes.UI_FirstName
                                  }
                                  title={data[1]}
                                />
                              </div>
                              <div className="gridcol-17 pe-0 gridcolSend-16 res-16p">
                                <input className={`form-control custom-inputBorder ${isDLRow ? "bg-light text-muted cursor-not-allowed" : ""}`}
                                  id={"lastName" + index}
                                  type="text"
                                  autoComplete="none"
                                  onChange={(evnt) => !isDLRow && handleChange(index, evnt)}
                                  value={data[2]}
                                  disabled={isDLRow}
                                  name={"lastName-" + index}
                                  placeholder={
                                    selectedLanguage
                                      .LstLanguageCodes.UI_LastName
                                  }
                                  title={data[2]}
                                />
                              </div>
                              {/* Country Code Dropdown and Mobile Number */}
                              {/* <div className="d-flex align-items-center res-w98"> */}
                            </div>
                            <div style={{ marginTop: "9px" }} className="gap-12p d-flex align-items-center mobile-flow w-max-content">
                              <div className="gridcol-17 pe-0 gridcolSend-16 mobile-flow w-max-content" >
                                <Select
                                  options={VerificationOptions}
                                  value={data[3]?.value ? data[3] : ""}
                                  isDisabled={isDLRow || props.securityLevel == 1}
                                  disabled={isDLRow || props.securityLevel == 1 ? true : false}
                                  placeholder={selectedLanguage.LstLanguageCodes.UI_SendVerificationCodeTo}
                                  className={`sendVerficationCodeBorder ${(props.securityLevel == 1 || isDLRow) ? "disable_section user_register" : ""}`}
                                  onChange={(event => !isDLRow && handleVerificationChange(event, index))}
                                  menuPortalTarget={document.body}
                                  closeMenuOnScroll={() => true}
                                  menuPosition="fixed"
                                  styles={{
                                    control: (provided) => ({
                                      ...provided,
                                      display: "flex",
                                      fontSize: "15px",
                                      width: "100%",
                                      minHeight: "40px",
                                      height: '40px',
                                      border: "1px solid !important",
                                    }),
                                    valueContainer: (provided) => ({
                                      ...provided,
                                      height: "40px",
                                    }),
                                    indicatorsContainer: (provided) => ({
                                      ...provided,
                                      height: "40px",
                                    }),
                                    placeholder: (provided) => ({
                                      ...provided,
                                      whiteSpace: "nowrap",
                                      overflow: "hidden",
                                      textOverflow: "ellipsis",
                                      textAlign: "center",
                                      width: "100%",
                                      cursor: "default",
                                    }),
                                    menu: (provided) => ({
                                      ...provided,
                                      zIndex: 99999,
                                      // width: "233px",
                                      overflow: "hidden",
                                      //marginTop: '18px',
                                      maxHeight: "300px",
                                      overflowY: "auto",
                                      //marginTop: "3px",
                                    }),
                                    menuPortal: (provided) => ({
                                      ...provided,
                                      zIndex: 99999,
                                      // width: "233px",
                                      //marginTop: '4px',
                                    }),

                                  }}

                                />
                              </div>
                              <div className="gridcol-25">
                                <div className="input-group custom-inputBorder" style={{ width: '100.5%' }}>
                                  <span
                                    className="input-group-text mobile-group50"
                                    style={{ padding: "0px", width: '37%' }}>
                                    <Select
                                      value={(resolveCountryCode(data[4]) || (data[4]?.value ? data[4] : null)) || globePlaceholder}
                                      isDisabled={isDLRow}
                                      onChange={(event) => !isDLRow && handleCodeChange(event, index)} // Pass index 0 to handle updates for the single reader
                                      options={countryCodeOptions}
                                      // placeholder={selectedLanguage.LstLanguageCodes.UI_CountryCode}
                                      menuPortalTarget={document.body}
                                      menuPosition="fixed"
                                      //closeMenuOnScroll={() => true}
                                      menuShouldScrollIntoView={false}
                                      styles={{
                                        control: (provided) => ({
                                          ...provided,
                                          display: 'flex',
                                          fontSize: '15px',
                                          width: '100%',
                                          minHeight: "40px",
                                          height: '40px',
                                          // alignItems: 'center',
                                          // justifyContent: 'center',
                                          // height: '45px',
                                          // width: '146px',
                                          // border: '1px solid #ccc',
                                          // borderRadius: '4px 0 0 4px',
                                          // marginLeft: '-37px',
                                          // overflow: 'hidden',
                                          // boxShadow: '1px 5px 5px -4px rgb(195 198 203)',
                                        }),
                                        valueContainer: (provided) => ({
                                          ...provided,
                                          height: "40px",
                                        }),
                                        indicatorsContainer: (provided) => ({
                                          ...provided,
                                          height: "40px",
                                        }),
                                        placeholder: (provided) => ({
                                          ...provided,
                                          whiteSpace: 'nowrap',
                                          overflow: 'hidden',
                                          textOverflow: 'ellipsis',
                                          textAlign: 'center',
                                          width: '100%',
                                          cursor: 'default',
                                        }),
                                        menu: (provided) => ({
                                          ...provided,
                                          zIndex: 9999,
                                          width: '233px',
                                          overflow: 'hidden',
                                          // marginTop: '18px',
                                          maxHeight: '300px',
                                          overflowY: 'auto',
                                        }),
                                        menuPortal: (provided) => ({
                                          ...provided,
                                          zIndex: 9999,
                                          width: '233px',
                                          //marginTop: '4px',
                                        }),
                                        indicatorSeparator: () => ({
                                          display: 'none',
                                        }),
                                      }}
                                      getOptionLabel={(e) => `${e.label}`}
                                      getOptionValue={(e) => `${e.value}`}
                                      title="Select code"
                                      formatOptionLabel={(data, { context }) => (
                                        <div style={{ display: 'flex', alignItems: 'center' }}>
                                          <div
                                            className={`${data.label === "+Code"
                                              ? "bg-  "
                                              : `bg-${data.languageCode}`
                                              }`}
                                            style={{
                                              width: '36px',
                                              height: '16px',
                                              marginRight: '8px',
                                            }}
                                          ></div>
                                          {context === 'menu' ? `${data.label}` : `${data.value ? data.value.split('-')[0] : ''}`}
                                        </div>
                                      )}
                                      noOptionsMessage={() => null}
                                    />
                                  </span>
                                  <input type="text"
                                    className={`form-control res-mobileinput res-mobileinputrightborder border-Left ${isDLRow ? "bg-light text-muted cursor-not-allowed" : ""}`}
                                    value={data[5]}
                                    disabled={isDLRow}
                                    maxLength={(data[4] == undefined || data[4] == null || data[4] == "" || data[4] == [] || data[4].value == "+Code") ? 10 : data[4].mobileMaxLeng}
                                    onChange={(evnt) => !isDLRow && handleMobileChange(evnt, index)}
                                    placeholder={selectedLanguage.LstLanguageCodes.UI_Mobile} title={data[5]} />
                                </div>

                              </div>

                              <div className="gridcol-17 pe-0 gridcolSend-16 res-16p">
                                <input className={`form-control custom-inputBorder ${isDLRow ? "bg-light text-muted cursor-not-allowed" : ""}`}
                                  id={"reference" + index}
                                  type="text"
                                  autoComplete="none"
                                  onChange={(evnt) => !isDLRow && handleChange(index, evnt)}
                                  value={data[6]}
                                  disabled={isDLRow}
                                  name={"reference-" + index}
                                  placeholder={
                                    selectedLanguage
                                      .LstLanguageCodes.UI_ReferenceTxt
                                  }
                                  title={data[6]}
                                />
                              </div>
                            </div>
                            <div className="gap-12p d-flex align-items-center mobile-flow w-max-content">
                              <div className="d-flex align-items-center" style={{ borderRadius: "0.25rem", margin: "10px 0px 0px 0px" }}>
                                <div className="checkbox mt-0 mb-0 d-flex align-items-center" style={{ border: "1px solid #ced4da", padding: "11px", whiteSpace: "nowrap" }}>
                                  <label className="ps-0 mb-0">
                                    <input
                                      type="checkbox"
                                      onChange={(e) => !isDLRow && handleChange(index, {
                                        target: { name: `canPrint-${index}`, checked: e.target.checked }
                                      })}
                                      value={canPrint}
                                      id="txtPrint"
                                      checked={props.defaultCanPrint && props.printEnabledType === "everyone" ? true : (data[7] || false)} disabled={isDLRow || (!props.defaultCanPrint || props.printEnabledType === "everyone")}
                                    />
                                    <span className="cr" tabIndex="42">
                                      <i className="cr-icon material-icons">check</i>
                                    </span>
                                    <span
                                      className={`toolltipModified  top`}
                                      onMouseEnter={handleMouseEnter}>
                                      {selectedLanguage.LstLanguageCodes.UI_CanPrint}
                                    </span>
                                  </label>
                                </div>
                                <div className="d-flex flex-grow-1 align-items-center">
                                  <div className="input-group field mt-0 res-nowwrap control-height custom-inputBorder me-3" style={{ flex: 1, minWidth: "150px" }}>
                                    <span className="input-group-text toolltipModified res-width forced-label-style truncate ellipsis-text ellipsis-text-max-keys" style={{ minWidth: "175px" }} title={selectedLanguage.LstLanguageCodes.UI_MaxPrintsPerReader}>
                                      {selectedLanguage.LstLanguageCodes.UI_MaxAllowedPrints}
                                    </span>
                                    <input
                                      type="text"
                                      placeholder={selectedLanguage.LstLanguageCodes.UI_Unlimited}
                                      title={maxPrintsPerReaderText === "" ? selectedLanguage.LstLanguageCodes.UI_Unlimited : ""}
                                      className={`control form-control h-47p border-Left ${isDLRow ? "bg-light text-muted cursor-not-allowed" : ""}`}
                                      value={props.securityLevel === 1 ? ""
                                        : ((props.defaultCanPrint && props.printEnabledType === "everyone")
                                          ? (data[9] === true
                                            ? (data[8] !== undefined && data[8] !== null ? data[8] : "")
                                            : (data[8] !== undefined && data[8] !== null ? data[8] : ""))
                                          : (!data[7] ? "" : (data[8] !== undefined && data[8] !== null ? data[8] : "")))
                                      }
                                      onChange={(e) => !isDLRow && handleChange(index, {
                                        target: { name: `maxPrintsPerReader-${index}`, value: e.target.value }
                                      })}
                                      disabled={isDLRow || props.securityLevel === 1 || !props.defaultCanPrint || !data[7]}
                                    />
                                  </div>
                                </div>
                              </div>
                              <div></div>
                              <div></div>
                            </div>
                          </div>
                        )}

                        <div className="col-12 col-sm-12 col-md-1 res-mobilCloseSend justify-content-end">
                          {consEditMultipleEmails.length !== 1 ? (
                            <button
                              className="btn btn-outline-danger d-flex res-px"
                              style={{
                                borderBottomColor: "#bc272e",
                                padding: "8px 10px",
                                verticalAlign: "middle",
                                position: "relative",
                                left: "10px"
                              }}
                              onClick={(e) => removeInputFields(constmultipleEmails, data[0], index)}
                            >
                              <span className="material-icons">backspace</span>
                            </button>
                          ) : (
                            ""
                          )}
                        </div>
                      </div>
                    );
                  })}
                  <div ref={endRef} ></div>
                </div>
              </div>

              <div className="pb-4 px-3 d-flex flex-wrap justify-content-between">
                <button
                  type="button"
                  className="btn btn-outline-success px-2 mt-3 ms-1 add-reader truncate"
                  data-bs-dismiss="modal"
                  ref={addReaderFocusRef}
                  title={selectedLanguage.LstLanguageCodes.UI_AddReader}
                  onClick={addInputField}
                >
                  <span
                    className="material-icons me-2 font-20"
                    style={{ verticalAlign: "bottom" }}
                  >
                    add_circle_outline{" "}
                  </span>
                  {selectedLanguage.LstLanguageCodes.UI_AddReader}
                </button>
                <div className="d-flex align-items-center mt-3">
                  <button
                    type="button"
                    title={selectedLanguage.LstLanguageCodes.UI_Cancel}
                    className="btn btn-danger px-2 me-2 ms-1 w-140p truncate"
                    data-bs-dismiss="modal"
                    onClick={(e) => handlerModelCancelForAddUser()}
                  >
                    {selectedLanguage.LstLanguageCodes.UI_Cancel}
                  </button>
                  <button
                    type="button"
                    title={selectedLanguage.LstLanguageCodes.UI_Save}
                    className="btn btn-primary px-2 ms-1 w-140p truncate"
                    onClick={(e) => handlerModelConfirmForAddUser(false)}
                  >
                    {selectedLanguage.LstLanguageCodes.UI_Save}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {isValidationPopup && (
        <div className="modalCus documentversion-history" id="myModal">
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="card-body pt-1">
                <div
                  className="mb-2 mt-3 justify-content-between d-flex"
                  style={{ borderBottom: "2px solid #918d8d4d" }}
                >
                  <h4 htmlFor="">
                    <p className="fw-bold">
                      {props.tabValue === "send"
                        ? "Recipients"
                        : "Authorized Readers"}
                    </p>
                  </h4>
                  <button
                    type="button"
                    className="btn btn-outline-danger modalclose download"
                    onClick={(e) => handleCloseValidationModal()}
                  >
                    <span className="material-icons font-20">
                      highlight_off
                    </span>
                  </button>
                </div>
                <div className="row">
                  <div>
                    <p className="IssuesUploadMsg">
                      {selectedLanguage.LstLanguageCodes.UI_ThefileYouAreTryingToUpload}
                    </p>
                  </div>
                </div>
                <div
                  className="card-body pt-0 recipent-scroll"
                  style={{
                    display: "block"
                  }}
                >
                  <div className="table-responsive res-card">
                    <table
                      className="fold-table table tablelayoutValidation "
                      cellPadding="0"
                      cellSpacing="0"
                    >
                      <thead className="bg-lightblue">
                        <tr className="">
                          <th className="" style={{ width: "19%" }}>
                            {selectedLanguage.LstLanguageCodes.UI_Sno}
                          </th>
                          <th className="" style={{ width: "33%" }}>
                            {selectedLanguage.LstLanguageCodes.UI_Inputvalue}
                          </th>
                          <th className="">{selectedLanguage.LstLanguageCodes.UI_Issue}</th>
                        </tr>
                      </thead>
                      <tbody>
                        {duplicateEmails.map((email, index) => (
                          <tr className="borderrow">
                            <td className="text-wrap">{counter++}</td>
                            <td className="text-wrap">{email[0]}</td>
                            <td className="text-wrap">{selectedLanguage.LstLanguageCodes.UI_DuplicateEmailAdress}</td>
                          </tr>
                        ))}
                        {emailLeanghtValidation.map((email, index) => (
                          <tr className="borderrow">
                            <td className="text-wrap">{counter++}</td>
                            <td className="wordbreakPopup text-wrap">{email[0]}</td>
                            {/* <td> */}
                            <td className="text-wrap">
                              {selectedLanguage.LstLanguageCodes.UI_EmailAdressContainsMoreThan255}
                            </td>
                            {/* </td> */}
                          </tr>
                        ))}
                        {invalidEmailsWithoutDotCom.map((email, index) => (
                          <tr className="borderrow">
                            <td className="text-wrap">{counter++}</td>
                            <td className="text-wrap">{email[0]}</td>
                            <td className="text-wrap">{selectedLanguage.LstLanguageCodes.UI_InvalidEmailAdress}</td>
                          </tr>
                        ))}
                        {localpartValiadation.map((email, index) => (
                          <tr className="borderrow">
                            <td className="text-wrap">{counter++}</td>
                            <td className="text-wrap">{email[0]}</td>
                            <td className="text-wrap">
                              {selectedLanguage.LstLanguageCodes.UI_LocalPartofEmailContainsMorethan64}
                            </td>
                          </tr>
                        ))}
                        {longDomainEmails.map((email, index) => (
                          <tr className="borderrow">
                            <td className="text-wrap">{counter++}</td>
                            <td className="text-wrap">{email[0]}</td>
                            <td className="text-wrap">
                              {selectedLanguage.LstLanguageCodes.UI_DomainContainsMoreThan190}{" "}
                            </td>
                          </tr>
                        ))}
                        {duplicateInFile.map((email, index) => (
                          <tr className="borderrow">
                            <td className="text-wrap">{counter++}</td>
                            <td className="text-wrap">{email[0]}</td>
                            <td className="text-wrap">Duplicate email address.</td>
                          </tr>
                        ))}
                        {longFirstName.map((email, index) => (
                          <tr className="borderrow">
                            <td className="text-wrap">{counter++}</td>
                            <td className="text-wrap">{email[1]}</td>
                            <td className="text-wrap">
                              {selectedLanguage.LstLanguageCodes.UI_FirstNameMoreThanFifty}{" "}
                            </td>
                          </tr>
                        ))}
                        {longLastName.map((email, index) => (
                          <tr className="borderrow">
                            <td className="text-wrap">{counter++}</td>
                            <td className="text-wrap">{email[2]}</td>
                            <td className="text-wrap">
                              {selectedLanguage.LstLanguageCodes.UI_LastNameMoreThanFifty}{" "}
                            </td>
                          </tr>
                        ))}
                        {longReference.map((email, index) => (
                          <tr className="borderrow">
                            <td>{counter++}</td>
                            <td>{email[6]}</td>
                            <td>
                              {
                                selectedLanguage.LstLanguageCodes
                                  .UI_ReferenceMoreThanFifty
                              }{" "}
                            </td>
                          </tr>
                        ))}
                        {invalidMobileNumbers.map((row, index) => (
                          <tr className="borderrow" key={index}>
                            <td className="text-wrap">{counter++}</td>
                            {/* <td>{row[3]}</td> Country Code */}
                            <td className="text-wrap">{row[5]}</td> {/* Mobile Number */}
                            <td className="text-wrap">{selectedLanguage.LstLanguageCodes.UI_EnterValidMobileNum}</td>
                          </tr>
                        ))}
                        {unauthorizedCountryCodes.map((row, index) => (
                          <tr className="borderrow" key={index}>
                            <td className="text-wrap">{counter++}</td>
                            <td className="text-wrap">{row[4]}</td> {/* Country Code */}
                            <td className="text-wrap">{selectedLanguage.LstLanguageCodes.UI_UnAuthorizedCountryCode}</td>
                          </tr>
                        ))}

                        {duplicateMobileNumbers.map((row, index) => (
                          <tr className="borderrow" key={index}>
                            <td className="text-wrap">{counter++}</td>
                            <td className="text-wrap">{row[5]}</td> {/* Mobile Number */}
                            <td className="text-wrap">{selectedLanguage.LstLanguageCodes.UI_DuplicateMobileNum}</td>
                          </tr>
                        ))}
                        {missingMobileNumbers.map((row, index) => (
                          <tr className="borderrow" key={index}>
                            <td className="text-wrap">{counter++}</td>
                            <td className="text-wrap">{row[4]?.value ? row[4].value : row[4]}</td> {/* Country Code */}
                            <td className="text-wrap">{selectedLanguage.LstLanguageCodes.UI_EnterAMobileNumber}</td>
                          </tr>
                        ))}
                        {missingCountryCodes.map((row, index) => (
                          <tr className="borderrow" key={index}>
                            <td className="text-wrap">{counter++}</td>
                            <td className="text-wrap">{row[5]}</td> {/* Mobile Number */}
                            <td className="text-wrap">{selectedLanguage.LstLanguageCodes.UI_EnterACountryCode}</td>
                          </tr>
                        ))}
                        {invalidOption.map((row, index) => (
                          <tr className="borderrow" key={index}>
                            <td className="text-wrap">{counter++}</td>
                            <td className="text-wrap">{row[3]}</td>
                            <td className="text-wrap">{selectedLanguage.LstLanguageCodes.UI_InvalidOption}</td>
                          </tr>
                        ))}
                        {textIsNotEnabled.map((row, index) => (
                          <tr className="borderrow" key={index}>
                            <td className="text-wrap">{counter++}</td>
                            <td className="text-wrap">{row[3]?.value}</td>
                            <td className="text-wrap">{selectedLanguage.LstLanguageCodes.UI_OptionToSendPasscodeByText}</td>
                          </tr>
                        ))}
                        {emailIsNotEnabled.map((row, index) => (
                          <tr className="borderrow" key={index}>
                            <td className="text-wrap">{counter++}</td>
                            <td className="text-wrap">{row[3]?.value}</td>
                            <td className="text-wrap">{selectedLanguage.LstLanguageCodes.UI_OptionToSendPasscodeByEmail}</td>
                          </tr>
                        ))}
                        {bothIsNotEnabled.map((row, index) => (
                          <tr className="borderrow" key={index}>
                            <td className="text-wrap">{counter++}</td>
                            <td className="text-wrap">{row[3]?.value}</td>
                            <td className="text-wrap">{row.errorMessage}</td>
                          </tr>
                        ))}
                        {invalidCanPrintValues.map((row, index) => (
                          <tr className="borderrow" key={index}>
                            <td className="text-wrap">{counter++}</td>
                            <td className="text-wrap">{row.invalidCanPrint}</td>
                            <td className="text-wrap">{selectedLanguage.LstLanguageCodes.UI_InvalidCanPrintValue || "Invalid Can print option Please enter (TRUE or FALSE)."}</td>
                          </tr>
                        ))}
                        {exceedMaxPrintsPerDoc.map((row, index) => (
                          <tr className="borderrow" key={index}>
                            <td className="text-wrap">{counter++}</td>
                            <td className="text-wrap">{row[8]}</td>
                            <td className="text-wrap">{selectedLanguage.LstLanguageCodes.UI_Printsperreadercannotexceedprintspersdocument}</td>
                          </tr>
                        ))}
                        {maxPrintsWithoutCanPrint.map((row, index) => (
                          <tr className="borderrow" key={index}>
                            <td className="text-wrap">{counter++}</td>
                            <td className="text-wrap">{row[8]}</td>
                            <td className="text-wrap">{"Can print should be enabled to configure Max allowed prints"}</td>
                          </tr>
                        ))}
                        {canPrintNotEnabledAtDocLevel.map((row, index) => (
                          <tr className="borderrow" key={index}>
                            <td className="text-wrap">{counter++}</td>
                            <td className="text-wrap">{row[0]}</td>
                            <td className="text-wrap">{"Can print must be enabled at the document level before it can be enabled for individual readers."}</td>
                          </tr>
                        ))}
                        {maxPrintsExceedLimit.map((row, index) => (
                          <tr className="borderrow" key={index}>
                            <td className="text-wrap">{counter++}</td>
                            <td className="text-wrap">{row[8]}</td>
                            <td className="text-wrap">{"The maximum limit for Max prints per reader should be less than 10,000"}</td>
                          </tr>
                        ))}
                        {invalidMaxPrintsValues.map((row, index) => (
                          <tr className="borderrow" key={index}>
                            <td className="text-wrap">{counter++}</td>
                            <td className="text-wrap">{row.invalidMaxPrints}</td>
                            <td className="text-wrap">{"Max prints per reader must be a valid number."}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      <>
        <ModalPopUp ref={unWarningModal} />
      </>
      {isDLModalOpen && (
        <DLDetailsModal
          isOpen={isDLModalOpen}
          onClose={() => {
            setIsDLModalOpen(false);
            setSelectedDLGroup(null);
          }}
          group={selectedDLGroup}
          contacts={props.contacts || []}
          contactGroups={props.contactGroups || []}
        />
      )}
    </>
  );
});
export default MultipleEmails;
